<template>
  <div class="checkout-wrapper layout">
    <div class="ms-row">
      <div class="col-xs-12">
        <div class="header-logo">
          <a class="logo" href="/">
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="130" height="40" viewBox="0 0 130 38" class="show-for-md svg-inline logo svg-inline--default">
              <path data-v-61dd7a3d="" fill="#000" fill-rule="nonzero" d="M77.37 37.923c-.918-.185-1.683-.676-1.995-1.281-.127-.248-.252-.825-.204-.948.022-.06.159-.077.58-.077h.55l.035.227c.142.885.967 1.34 2.423 1.338.953-.002 1.785-.24 2.022-.578.269-.383.217-.871-.124-1.153-.276-.229-.718-.358-2.011-.589-1.6-.285-1.881-.351-2.255-.528-.631-.299-.906-.705-.908-1.34-.005-1.436 1.5-2.27 3.695-2.05.748.075 1.158.178 1.617.404.588.29 1.008.866 1.097 1.504l.036.264h-.586c-.521 0-.586-.01-.587-.097-.001-.221-.273-.677-.504-.845-.902-.654-2.99-.528-3.448.208-.183.296-.178.726.01.932.236.255.532.342 2.14.63 1.953.35 2.409.505 2.79.944.298.345.372.561.372 1.09 0 .434-.02.537-.149.783-.19.362-.466.602-.965.839-.62.295-1.27.405-2.355.4-.513-.003-1.075-.037-1.277-.077zm-30.425-3.446v-3.361h2.28c2.56 0 2.794.025 3.364.368.446.269.552.38.752.786.149.302.173.411.17.768-.004.797-.476 1.44-1.297 1.772l-.41.165-1.791.02-1.79.018v2.826h-1.278v-3.362zm4.423-.388c.6-.178.875-.519.877-1.084 0-.417-.16-.672-.545-.86-.387-.19-.958-.25-2.353-.25l-1.125-.001v2.278h1.434c1.108 0 1.496-.019 1.712-.083zm2.105 3.575c.087-.168 1.19-2.42 2.562-5.229l.644-1.32H58.084l.505 1.07c1.3 2.752 2.624 5.59 2.624 5.62 0 .019-.296.034-.658.034h-.66l-.434-.972-.435-.973-1.724.001-1.724.001-.444.97-.444.97-.654.002-.653.001.09-.175zm4.502-4.02c-.338-.78-.628-1.417-.645-1.417-.025 0-1.219 2.499-1.319 2.76-.023.06.21.074 1.275.074h1.304l-.615-1.417zm4.793.833v-3.361h2.405c2.555 0 2.8.019 3.444.269.72.279 1.09.802 1.09 1.537 0 .657-.315 1.18-.889 1.473l-.234.12.28.13c.327.15.596.482.645.793.018.113.056.578.086 1.032.055.862.11 1.048.333 1.119.062.02.113.084.113.143 0 .1-.046.107-.749.107h-.748l-.034-.153a3.4 3.4 0 0 0-.059-.233 11.53 11.53 0 0 1-.074-.9c-.051-.847-.084-.97-.326-1.23-.271-.291-.537-.331-2.382-.36l-1.68-.025v2.901h-1.221v-3.362zm4.872-.44c.358-.113.651-.36.738-.624.093-.283.043-.82-.095-1.006-.174-.236-.519-.398-.97-.457-.225-.029-1.065-.054-1.866-.055l-1.458-.001v2.292l1.68-.028c1.353-.023 1.736-.046 1.971-.12zm4.288.44v-3.361h1.221V37.839h-1.22v-3.362zm39.973-2.064l-.708-.051-.458-.034v-3.094l.912.033c1.034.036 1.539-.023 2.206-.26 1.092-.386 1.937-1.165 2.546-2.345.255-.495.604-1.435.693-1.867l.037-.182-.38.028c-.208.015-.922.04-1.586.058l-1.207.03-.438-.904-1.034-2.127-1-2.056c-.22-.459-.708-1.459-1.082-2.223-.374-.764-.86-1.764-1.083-2.222-.221-.459-.696-1.434-1.055-2.167-2.09-4.277-2.747-5.64-2.747-5.7 0-.03 1.324-.05 3.345-.05h3.345l.634 1.458c1.632 3.748 2.825 6.476 3.447 7.876.373.84.848 1.94 1.056 2.444.71 1.726 1.254 2.966 1.306 2.983.029.009.288-.752.577-1.691.288-.94.684-2.17.88-2.736.859-2.488 1.612-4.685 2.313-6.751.415-1.223.85-2.498.968-2.834l.213-.611 3.2-.015c1.76-.007 3.199-.002 3.199.012s-.284.783-.631 1.71c-.347.925-.92 2.457-1.273 3.405a56127.836 56127.836 0 0 1-3.187 8.557c-2.254 6.075-2.434 6.514-3.145 7.667-1.539 2.498-3.307 3.402-7.115 3.64-.82.05-2.151.06-2.748.019zM9 24.91c-2.488-.099-4.601-.397-5.932-.836-1.83-.605-2.84-1.857-3.033-3.759C0 19.991-.01 19.6.01 19.447l.037-.277h3.24c1.783 0 3.241.006 3.24.013 0 .008-.037.152-.082.32-.165.616-.083 1.081.262 1.473.67.76 2.303 1.138 4.935 1.138 2.68 0 4.472-.367 5.316-1.09.532-.455.681-1.258.366-1.962-.26-.577-.771-.94-1.663-1.175-.385-.102-.689-.124-2.276-.166-5.38-.143-7.102-.266-8.954-.641-1.478-.3-2.25-.654-2.956-1.355-.376-.375-.523-.57-.71-.945-.403-.811-.475-1.187-.48-2.473-.002-1 .01-1.155.126-1.553.07-.243.219-.618.33-.833.261-.505.954-1.212 1.466-1.496 1.012-.562 2.536-.896 5.16-1.129 1.379-.122 7.245-.143 8.572-.03 2.476.211 3.936.515 4.94 1.03.867.442 1.583 1.357 1.832 2.34.09.357.195 1.113.195 1.406v.182H16.763l-.099-.457c-.186-.87-.518-1.303-1.138-1.488-.603-.18-1.165-.226-3.113-.26-1.976-.034-2.792.011-3.672.204-.767.167-1.285.41-1.66.776-.375.368-.466.608-.458 1.206.012.863.31 1.37.907 1.54.581.168 2.414.305 5.66.424 4.944.182 7.69.591 8.944 1.333.513.304.997.84 1.265 1.404.369.773.422 1.074.423 2.375 0 1.281-.07 1.661-.446 2.407-1.05 2.08-3.397 2.923-8.909 3.204-.957.049-4.415.06-5.468.02zm39.251-.021c-5.51-.304-7.6-1.228-8.302-3.67-.086-.3-.127-.634-.149-1.23l-.03-.82h3.255c1.79 0 3.255.015 3.255.033 0 .019-.04.188-.089.375-.346 1.326.62 2.101 3.032 2.436.805.111 3.833.094 4.695-.026 1.762-.247 2.84-.743 3.192-1.47.193-.398.184-1.052-.022-1.473-.28-.573-.785-.92-1.68-1.16-.38-.1-.687-.122-2.271-.165-4.46-.119-6.026-.204-7.579-.414-2.605-.351-3.897-.897-4.696-1.984-.55-.747-.791-1.535-.839-2.744-.075-1.887.419-3.08 1.636-3.95.985-.704 2.663-1.1 5.732-1.351 1.168-.096 5.883-.134 7.3-.058 4.796.254 6.685.933 7.52 2.703.224.473.384 1.143.428 1.789l.036.514-3.071-.014-3.071-.015-.129-.525c-.36-1.471-.834-1.637-4.683-1.64-1.825-.001-2.226.013-2.745.1-1.071.181-1.86.516-2.243.953-.275.313-.359.62-.33 1.207.04.866.3 1.289.894 1.46.566.162 2.425.3 5.645.418 5.064.187 7.853.614 9.035 1.385.524.342.88.745 1.156 1.307.297.606.392.965.473 1.776.12 1.204-.078 2.341-.57 3.27-.25.467-1.015 1.238-1.523 1.532-1.278.738-3.124 1.153-6.239 1.401-.978.078-5.881.113-7.023.05zm41.666.025c-3.506-.188-5.54-.564-7.023-1.298-.986-.488-1.526-1.02-2.053-2.017-.459-.868-.746-1.886-.954-3.375-.14-1.006-.14-3.76 0-4.69.292-1.947.912-3.334 1.894-4.238.482-.445.838-.67 1.53-.969 1.188-.512 2.817-.847 5.163-1.06 1.1-.1 5.904-.1 6.967 0 2.894.272 4.818.79 5.91 1.592 1.125.827 1.845 2.208 2.173 4.17.094.562.202 2.372.215 3.598l.002.208H86.201l-.038.203c-.067.36.02 1.736.14 2.227.208.84.594 1.436 1.17 1.804.872.556 3.04.823 5.775.711 2.822-.116 3.627-.413 4-1.478.064-.18.13-.522.147-.758l.032-.431h6.319l-.035.625c-.059 1.066-.202 1.567-.624 2.19-1.063 1.566-3.409 2.495-7.286 2.885-.812.081-4.927.152-5.885.1zM97.45 13.46c-.084-1.908-.582-2.585-2.132-2.899-1.504-.304-4.548-.36-6.178-.113-1.062.16-1.797.45-2.14.845-.413.475-.675 1.304-.73 2.306l-.034.625h11.248l-.034-.764zM28.68 16.058V7.39H35.009v17.336H28.68v-8.668zm39.75-3.695V0h6.33v24.726H68.43V12.363zM28.68 1.75V0H35.009v3.5H28.68V1.75z"></path>
            </svg>
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="81" height="24" viewBox="0 0 81 24" class="hide-for-md svg-inline logo-small svg-inline--default">
              <path data-v-61dd7a3d="" fill="#000" fill-rule="nonzero" d="M48.029 23.696c-.57-.115-1.045-.422-1.238-.8-.079-.155-.156-.515-.127-.592.014-.037.099-.049.36-.049h.34l.023.142c.088.553.6.838 1.504.836.592-.001 1.108-.15 1.256-.36.166-.24.134-.545-.077-.721-.172-.143-.446-.224-1.249-.368-.993-.179-1.167-.22-1.4-.33-.391-.187-.562-.44-.563-.838-.003-.897.93-1.418 2.293-1.28.465.047.72.11 1.004.252.365.18.626.541.681.94l.023.165h-.364c-.324 0-.364-.007-.364-.06-.001-.14-.17-.424-.313-.529-.56-.408-1.857-.33-2.14.13-.115.185-.112.454.006.582.146.16.33.214 1.328.394 1.212.22 1.495.315 1.731.59.186.215.232.35.232.68 0 .272-.013.337-.093.49-.118.227-.289.376-.599.525-.385.184-.788.253-1.462.25a5.744 5.744 0 0 1-.792-.049zm-18.887-2.153v-2.1h1.415c1.59 0 1.735.016 2.089.23.277.168.343.237.467.49.092.19.107.258.106.481-.004.498-.296.9-.806 1.107l-.255.104-1.112.012-1.111.011v1.766h-.793v-2.1zm2.746-.242c.372-.112.543-.324.544-.678 0-.26-.1-.42-.338-.537-.24-.118-.595-.156-1.461-.157h-.698v1.424h.89c.688 0 .929-.012 1.063-.052zm1.307 2.233c.053-.104.739-1.512 1.59-3.266l.4-.825h.872l.314.668c.806 1.72 1.629 3.493 1.629 3.512 0 .011-.184.021-.41.021h-.408l-.27-.608-.27-.607h-1.07l-1.07.001-.276.606-.276.606-.406.001-.406.001.057-.11zm2.794-2.511c-.21-.487-.39-.886-.4-.885-.016 0-.757 1.56-.819 1.724-.014.038.13.046.792.046h.809l-.382-.885zm2.976.52v-2.1h1.492c1.587 0 1.738.012 2.139.168.446.174.677.501.677.96 0 .411-.196.738-.553.92l-.145.076.174.08c.203.095.37.302.4.497.011.07.035.36.053.645.035.538.07.654.207.698.039.013.07.053.07.09 0 .063-.028.067-.464.067h-.465l-.02-.095a2.136 2.136 0 0 0-.037-.146 7.25 7.25 0 0 1-.047-.562c-.031-.53-.051-.607-.202-.769-.168-.182-.333-.207-1.479-.225l-1.042-.016V23.644h-.758v-2.1zm3.024-.275c.223-.07.404-.225.458-.39.058-.176.027-.512-.059-.628-.108-.148-.322-.249-.602-.286-.14-.018-.661-.033-1.159-.034l-.904-.001v1.432l1.042-.017c.84-.015 1.078-.03 1.224-.076zm2.662.275v-2.1h.758V23.644h-.758v-2.1zm24.814-1.29l-.44-.031-.284-.021v-1.934l.566.02c.642.023.956-.014 1.37-.161.678-.242 1.202-.728 1.58-1.466.158-.31.375-.897.43-1.167l.023-.113-.235.017c-.13.01-.573.026-.985.036l-.75.02-.271-.566-.642-1.329c-.204-.42-.483-.998-.62-1.285-.138-.286-.44-.911-.673-1.388l-.672-1.39c-.137-.286-.432-.895-.654-1.353-1.298-2.673-1.706-3.524-1.706-3.562 0-.019.822-.032 2.076-.031h2.077l.394.911a910.135 910.135 0 0 0 2.139 4.921c.232.525.527 1.213.656 1.528.441 1.078.778 1.853.81 1.863.018.006.18-.47.359-1.056.179-.587.424-1.357.546-1.71.533-1.554 1-2.927 1.436-4.218l.6-1.771.133-.382 1.986-.009c1.093-.005 1.986-.002 1.986.007 0 .01-.176.49-.392 1.068l-.79 2.128a35333.86 35333.86 0 0 1-1.978 5.347c-1.4 3.796-1.511 4.07-1.952 4.791-.956 1.56-2.053 2.126-4.417 2.274a17.01 17.01 0 0 1-1.706.012zM5.586 15.566c-1.544-.062-2.856-.248-3.682-.523-1.136-.378-1.763-1.16-1.883-2.348a3.188 3.188 0 0 1-.015-.543l.023-.174h2.012c1.106 0 2.011.004 2.011.009 0 .005-.023.095-.051.2-.103.385-.051.675.163.92.415.475 1.43.711 3.063.711 1.664 0 2.776-.229 3.3-.68.33-.285.423-.787.227-1.227-.16-.36-.478-.587-1.032-.734-.239-.064-.428-.078-1.413-.104-3.34-.09-4.409-.166-5.558-.4-.918-.188-1.398-.41-1.835-.847-.234-.234-.325-.356-.44-.59C.224 8.727.18 8.493.176 7.69c-.001-.625.006-.721.078-.97.043-.152.136-.386.205-.521.162-.315.592-.757.91-.935.628-.35 1.575-.56 3.203-.705.856-.076 4.498-.09 5.321-.018 1.537.131 2.444.321 3.068.642.537.277.982.849 1.136 1.463.056.223.121.696.121.879v.113H10.406l-.061-.285c-.116-.544-.322-.815-.707-.93-.374-.112-.723-.142-1.932-.163-1.227-.02-1.733.008-2.28.128-.476.104-.798.256-1.03.485-.233.23-.29.38-.285.754.008.539.193.855.564.962.36.104 1.498.19 3.513.265 3.069.113 4.774.37 5.552.833.319.19.62.525.786.877.228.483.262.671.262 1.484 0 .8-.044 1.038-.277 1.504-.652 1.3-2.109 1.827-5.53 2.002-.594.03-2.741.038-3.395.012zm24.366-.013c-3.42-.19-4.717-.768-5.154-2.294-.053-.187-.078-.396-.092-.769l-.019-.512h2.021c1.111 0 2.02.01 2.02.021 0 .012-.024.117-.054.235-.215.828.384 1.313 1.881 1.521.5.07 2.38.06 2.915-.016 1.094-.154 1.763-.464 1.982-.918.12-.249.114-.658-.014-.92-.174-.358-.487-.576-1.043-.725-.236-.063-.427-.077-1.41-.103-2.768-.075-3.74-.128-4.704-.259-1.618-.22-2.42-.56-2.916-1.24-.341-.467-.49-.96-.52-1.714-.047-1.18.26-1.925 1.015-2.469.611-.44 1.653-.687 3.558-.844.725-.06 3.652-.083 4.532-.036 2.977.158 4.15.583 4.668 1.689.139.295.239.714.266 1.117l.022.322L37 7.629l-1.907-.008-.08-.328c-.223-.92-.517-1.023-2.907-1.025-1.132-.001-1.382.008-1.704.063-.665.113-1.154.322-1.392.595-.17.195-.223.387-.205.754.025.541.186.806.555.912.351.101 1.505.188 3.504.262 3.144.116 4.875.384 5.609.865.325.214.546.466.717.817.185.378.244.603.294 1.11.075.752-.048 1.462-.354 2.042-.155.293-.63.774-.945.958-.794.461-1.94.72-3.873.876-.607.048-3.651.07-4.36.03zm25.865.015c-2.176-.117-3.438-.352-4.36-.811-.611-.305-.947-.637-1.274-1.26-.285-.543-.463-1.179-.592-2.109-.087-.629-.087-2.35 0-2.93.181-1.217.566-2.084 1.175-2.649.3-.278.52-.418.95-.605.738-.32 1.75-.53 3.205-.662.683-.063 3.666-.063 4.326 0 1.796.17 2.99.493 3.668.994.699.517 1.146 1.38 1.35 2.606.057.351.125 1.482.133 2.248v.13H53.512l-.023.127c-.042.225.012 1.085.087 1.392.128.524.368.897.726 1.127.541.347 1.886.514 3.585.444 1.751-.072 2.251-.258 2.483-.923.04-.113.08-.326.091-.474l.02-.27h3.923l-.022.391c-.037.666-.126.98-.388 1.368-.66.98-2.115 1.56-4.522 1.803-.505.051-3.059.095-3.654.063zm4.677-7.157c-.053-1.193-.362-1.616-1.324-1.812-.933-.19-2.823-.225-3.835-.07-.66.1-1.115.281-1.329.528-.256.296-.418.814-.453 1.44l-.02.391h6.982l-.021-.477zm-42.69 1.623V4.618H21.733V15.45H17.804v-5.416zM42.48 7.725V0H46.409v15.45H42.48V7.725zM17.804 1.094V0H21.733V2.187H17.804V1.094z"></path>
            </svg>
          </a>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="header-breadcrumb">
          <router-link to="/cart" class="link-with-arrow link-with-arrow--secondary">返回购物车</router-link>
        </div>
      </div>
      <!-- 左侧 -->
      <div class="col-xs-12 col-md-8 float-left">
        <div class="page-title heading-h2">订单结算</div>
        <!-- 配送信息 -->
        <div class="item-tile shipping-address">
          <template v-if="member_info && member_info.shipping_address && member_info.shipping_address.length">
            <div class="tile-title space-between">
              <div class="heading-h4">配送信息</div>
              <div class="btn title-btn" @click="addNewAddress">+ 添加地址</div>
            </div>
            <div class="tile-container address-list">
              <div :class="['address-item clickable', address.shipping_address_id == selectedAddress ? 'active' : '']" 
                v-for="(address, addressIndex) in member_info.shipping_address" :key="addressIndex" 
                @click="toggleAddress(address)"
              >
                <i class="iconfont tick">&#xe66d;</i>
                <div class="address-extra">
                  <div class="user-info">
                    <div class="user-name">{{address.name}}</div>
                    <div class="user-mobile">{{address.mobile}}</div>
                  </div>
                  <div class="address-items">{{address.province}} {{address.city}} {{address.district}} {{address.address_detail}}</div>
                </div>
                <div class="address-actions">
                  <div class="address-isDefault" @click.stop="setDefault(address)">{{address.is_default ? '' : '设为'}}默认地址</div>
                  <div class="address-btns">
                    <i class="iconfont" @click.stop="removeAddress(address)">&#xe614;</i>
                    <i class="iconfont" @click.stop="editAddress(address)">&#xe601;</i>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="tile-title space-between">
              <div class="heading-h4">配送信息</div>
              <div class="title-desc">*号为必填</div>
            </div>
            <div class="tile-container tile-border tile-padding">
              <VForm class="ms-row" :model="addressForm" :rule="addressFormRules" ref="addressForm">
                <div class="col-xs-12 col-md-6">
                  <FormItem prop="name">
                    <input type="text" class="c-input c-input--fullwidth" placeholder="* 收货人姓名" v-model.trim="addressForm.name" maxlength="20" />
                  </FormItem>
                </div>
                <div class="col-xs-12 col-md-6">
                  <FormItem prop="sex">
                    <MultiSelect v-model="addressForm.sex" :options="sexOpts" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="* 称谓"/>
                  </FormItem>
                </div>
                <div class="col-xs-12 col-md-6">
                  <FormItem prop="mobile">
                    <input type="text" class="c-input c-input--fullwidth" placeholder="* 电话号码" v-model.trim="addressForm.mobile" maxlength="11" />
                  </FormItem>
                </div>
                <div class="col-xs-12 col-md-6">
                  <FormItem prop="regions">
                    <!-- <Cascader textField="name" valueField="isocode" extraCls="cascader-cls" 
                      :source="districts" v-model="[addressForm.province, addressForm.city, addressForm.county]"
                    /> -->
                    <Cascader textField="name" valueField="name" hint="* 所在省市区" extraCls="cascader-cls" :source="districts" v-model="addressForm.regions"/>
                  </FormItem>
                </div>
                <div class="col-xs-12 col-md-6">
                  <FormItem prop="detail">
                    <input type="text" class="c-input c-input--fullwidth" placeholder="* 详细地址" maxlength="30" v-model.trim="addressForm.detail"/>
                  </FormItem>
                </div>
                <div class="col-xs-12 col-md-6">
                  <FormItem prop="zip_code">
                    <input type="text" class="c-input c-input--fullwidth" placeholder="邮政编码（选填）" v-model.trim="addressForm.zip_code" maxlength="6"  />
                  </FormItem>
                </div>
                <div class="col-xs-12 col-md-6" v-if="isLogin">
                  <div class="default_address_opts float-left" @click="toggleDefAddress(addressForm)">
                    <i class="iconfont">{{addressForm.is_default ? '&#xedaf;' : '&#xec58;'}}</i>设为默认地址
                  </div>
                </div>
                <div class="col-xs-12 col-md-6" v-if="isLogin">
                  <div class="save_address_info float-right">
                    <button class="btn" @click="saveInfo">添加地址</button>
                  </div>
                </div>
              </VForm>
            </div>
          </template>
        </div>
        <!-- 配送方式 -->
        <div class="item-tile choose-shipping-method">
          <div class="tile-title clearfix">
            <div class="heading-h4 float-left">配送方式</div>
            <div class="title-desc float-left">(所有订单将优先使用顺丰速运提供免费送货服务，对于顺丰无法送到的地区，我们将使用EMS运送）</div>
          </div>
          <div class="tile-container">
            <div class="module ">
              <div class="module_container">
                <div :class="['choose-option', 'active']">
                  <!-- <i class="iconfont tick">&#xe66d;</i> -->
                  <i class="iconfont sf-express">&#xe65a;</i>
                  <span class="option-name">顺丰免费配送</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 支付方式 -->
        <div class="item-tile choose-payment-method">
          <div class="tile-title clearfix">
            <div class="heading-h4 float-left">支付方式</div>
          </div>
          <div class="tile-container">
            <!-- 线上支付 -->
            <div class="module online_payment">
              <div class="module_header clearfix">
                <div class="module_title float-left">线上支付</div>
                <!-- <div class="module_desc float-left">(支付时可以选择第三方支付账户来支付您的订单）</div> -->
              </div>
              <!-- 支付方式 -->
              <div class="module_container">
                <div :class="['choose-option', paymentMethod == item.value ? 'active' : '']" v-for="(item, i) in allowPayMethod" :key="`PayMethod-${i}`" @click="togglePayment(item.value)">
                  <i class="iconfont tick">&#xe66d;</i>
                  <!-- <i :class="['iconfont', item.iconCls]" v-html="item.iconText"></i> -->
                  <svg :class="['icon', item.iconCls]" aria-hidden="true">
                    <use :xlink:href="`#${item.iconSymbol}`"></use>
                  </svg>
                  <span class="option-name">{{item.text}}</span>
                </div>
              </div>
              <!-- 花呗分期 -->
              <div :class="['module_container', 'stages_wrap', `stages_${Math.min(allowPayStages.length, 4)}`]" v-if="paymentMethod == 'HuabeiPay'">
                <div :class="['choose-option', paymentStage == item.hb_fq_num ? 'active' : '']" v-for="(item, i) in allowPayStages" :key="`PayStage-${i}`" @click="toggleStage(item.hb_fq_num)">
                  <i class="iconfont tick">&#xe66d;</i>
                  <div class="option-name">
                    <span class="">{{item.hb_fq_num}} 期，{{item.rate}} 费率</span>
                    <span class="">RMB {{item.principal}}</span>
                  </div>
                  <div class="option-desc">
                    <span class="">RMB {{item.total_amount}} — {{payRate || ''}}</span>
                    <span class="">每月支付</span>
                  </div>
                </div>
                <div class="stage_msg" v-if="payTitle">{{payTitle}}</div>
              </div>
            </div>
            <!-- 货到付款 -->
            <div class="module offline_payment" v-if="enableOfflinePayment">
              <div class="module_header clearfix">
                <div class="module_title float-left">货到付款</div>
                <div class="module_desc float-left">(当您收到货时请准备好现金或银行卡进行支付，如果需要退货退款，请联系客服，将会通过银行转账方式进行退款)</div>
              </div>
              <div class="module_container">
                <div :class="['choose-option', paymentMethod == 'Offline' ? 'active' : '']" @click="togglePayment('Offline')">
                  <i class="iconfont tick">&#xe66d;</i>
                  <i class="iconfont freight_collect">&#xe658;</i>
                  <span class="option-name">货到付款</span>
                </div>
              </div>
            </div>
            <!-- 积分抵扣 -->
            <!-- <div class="module" v-if="used_points && used_points.points && used_points.money">
              <div class="module_header clearfix">
                <div class="module_title use_score float-left clickable" @click="toggleDiscount">
                  <i class="iconfont">{{useDiscount ? '&#xe640;':'&#xe60f;'}}</i>使用{{used_points.points}}积分抵扣{{used_points.money}}元
                </div>
              </div>
            </div> -->
            <!-- 电子发票 -->
            <div class="module ">
              <div class="module_header clearfix">
                <div class="module_title use_score float-left clickable" @click="toggleInvoice">
                  <i class="iconfont">{{invoice ? '&#xe640;':'&#xe60f;'}}</i>电子发票
                </div>
                <div class="module_desc float-left">(增值税普通电子发票申请后，将在订单签收的15个工作日之后发送至邮箱，也可在“我的订单-已支付”中重新发送)</div>
              </div>
              <div class="module_container">
                <div class="field-box" v-if="invoice">
                  <VForm class="ms-row" :model="invoice" :rule="invoiceRule" ref="invoice">
                    <div class="col-xs-12 col-md-6">
                      <FormItem prop="type">
                        <MultiSelect v-model="invoice.type" :options="invoiceOpts" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="* 请选择发票类型"/>
                      </FormItem>
                    </div>
                    <div class="col-xs-12 col-md-6">
                      <FormItem prop="title">
                        <input type="text" class="c-input c-input--fullwidth" placeholder="* 请输入抬头名称" v-model.trim="invoice.title" maxlength="30" />
                      </FormItem>
                    </div>
                    <div class="col-xs-12 col-md-6">
                      <FormItem prop="id">
                        <input type="text" class="c-input c-input--fullwidth" :placeholder="invoice.type == '企业' ? '* 纳税人识别号' : '纳税人识别号（选填）'" v-model.trim="invoice.id" maxlength="30" />
                      </FormItem>
                    </div>
                    <div class="col-xs-12 col-md-6">
                      <FormItem prop="email">
                        <input type="text" class="c-input c-input--fullwidth" placeholder="* 电子邮箱（发票将发送至此邮箱）" v-model.trim="invoice.email" maxlength="30" />
                      </FormItem>
                    </div>
                  </VForm>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 需要贺卡 -->
        <div class="item-tile border-top greeting-card">
          <div class="tile-container">
            <div class="module ">
              <div class="module_header clearfix">
                <div class="module_title use_score float-left clickable" @click="toggleGreetingCard">
                  <i class="iconfont">{{greetingCard ? '&#xe640;':'&#xe60f;'}}</i>需要礼品卡
                </div>
              </div>
              <div class="module_container " v-if="greetingCard">
                <div class="field-box">
                  <VForm class="ms-row" :model="greetingCard" ref="greetingCard" :rule="greetingCardRules">
                    <div class="col-xs-12 col-md-6">
                      <FormItem prop="to">
                        <input type="text" class="c-input c-input--fullwidth" placeholder="* 致（必填）" v-model.trim="greetingCard.to" maxlength="20"/>
                      </FormItem>
                    </div>
                    <div class="col-xs-12 col-md-6">
                      <FormItem prop="from">
                        <input type="text" class="c-input c-input--fullwidth" placeholder="* 来自（必填）" v-model.trim="greetingCard.from" maxlength="20"/>
                      </FormItem>
                    </div>
                    <div class="col-xs-12">
                      <FormItem prop="content">
                        <div class="ipt-multi-wrap" data-max="100" :data-count="greetingCard.content.length">
                          <textarea class="c-input c-input--fullwidth ipt-multi" placeholder="* 信息（必填）" v-model.trim="greetingCard.content" maxlength="100"></textarea>
                        </div>
                      </FormItem>
                    </div>
                  </VForm>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 备注 -->
        <div class="item-tile border-top greeting-card">
          <div class="tile-container">
            <div class="module ">
              <div class="module_header clearfix">
                <div class="module_title use_score float-left clickable" @click="toggleRemark">
                  <i class="iconfont">{{order_remark.show ? '&#xe640;':'&#xe60f;'}}</i>备注
                </div>
              </div>
              <div class="module_container " v-if="order_remark.show">
                <div class="field-box">
                  <VForm>
                    <div>
                      <FormItem prop="to">
                        <input type="text" class="c-input c-input--fullwidth" placeholder="请输入您的留言" v-model.trim="order_remark.value" maxlength="100"/>
                      </FormItem>
                    </div>
                  </VForm>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 隐私政策 -->
        <div class="item-tile border-top">
          <div class="tile-container">
            <div class="module">
              <div class="module_header nowrap clearfix">
                <div class="module_title use_score float-left" @click="togglePrivacy">
                  <i class="iconfont">{{agree ? '&#xe640;':'&#xe60f;'}}</i>
                </div>
                <div class="module_desc float-left ml0 clickable" @click="togglePrivacy">
                  我已阅读并了解Sisley法国希思黎中国官网的
                  <router-link to="/terms" target="_blank" @click.native.stop rel="nofollow">条款和条件</router-link>
                  和
                  <router-link to="/privacy" target="_blank" @click.native.stop rel="nofollow">隐私政策</router-link>，并同意接受其所有的条款
                </div>
              </div>
              <div class="privacy_err--msg" v-if="privacyCheckError">{{privacyCheckError}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="col-xs-12 col-md-3 col-md-offset-1 float-right">
        <!-- 订单摘要 -->
        <div class="item-tile summary">
          <div class="tile-container" v-if="total">
            <!-- 金额信息 -->
            <div class="heading-h5">订单摘要</div>
            <div class="kv-items">
              <div class="kv-line">
                <div class="kv-name">商品金额</div>
                <div class="kv-value">￥{{ total.total_product_price | toFixed(2) }}</div>
              </div>
              <div class="kv-line">
                <div class="kv-name">优惠金额</div>
                <div class="kv-value">-￥{{ total.total_discount | toFixed(2) }}</div>
              </div>
              <div class="kv-line">
                <div class="kv-name">运费</div>
                <div class="kv-value" v-if="total.total_ship_fee > 0">+¥{{ total.total_ship_fee | toFixed(2) }}</div>
                <div class="kv-value" v-else>免费</div>
              </div>
              <div class="kv-line">
                <div class="kv-name">包装</div>
                <div class="kv-value" v-if="total.total_wrap_fee > 0">+¥{{ total.total_wrap_fee | toFixed(2) }}</div>
                <div class="kv-value" v-else>免费</div>
              </div>
            </div>
            <!-- 电子礼券 -->
            <div class="tab-wrap" v-if="isLogin">
              <div class="tab-header">
                <div :class="['tab-title', eGiftCardType == 1 ? 'active' : '']" @click="toggleEGiftCard(1)">使用电子礼券</div>
                <div :class="['tab-title', eGiftCardType == 2 ? 'active' : '']" @click="toggleEGiftCard(2)">输入电子礼券优惠码</div>
              </div>
              <div class="tab-body">
                <div class="e-gift_card" v-if="eGiftCardType == 1">
                  <CouponSelect :couponCard="couponCard" :couponList="member_info.coupon_list" @onConfirm="couponConfirm"></CouponSelect>
                </div>
                <div class="e-gift_card_code" v-if="eGiftCardType == 2">
                  <input class="c-input c-input--fullwidth" v-model.trim="eGiftCardCode" placeholder="请输入电子礼券优惠码" @blur="onCouponCodeBlur" />
                </div>
              </div>
            </div>
            <!-- 总计 -->
            <div class="total-info">
              <div class="kv-line">
                <div class="kv-name">总计</div>
                <div class="kv-value">￥{{total.total_amount}}</div>
              </div>
            </div>
            <div class="create-order__btn">
              <button class="btn--primary" @click="toCheckout">结算</button>
            </div>
            <div class="payment-methods">
              <i class="iconfont">&#xe65f;</i>
              <i class="iconfont">&#xe65b;</i>
              <i class="iconfont">&#xe65d;</i>
              <i class="iconfont">&#xe659;</i>
              <i class="iconfont">&#xe658;</i>
            </div>
          </div>
        </div>
        <!-- 商品清单 -->
        <div class="item-tile goods-list">
          <div class="tile-container">
            <div class="heading-h5">商品清单</div>
            <div class="subtitle">选购商品</div>
            <div class="goods-items" v-if="goods_list && goods_list.goods">
              <template v-for="outerItem in goods_list.goods">
                <template v-for="(innerItem, innerIndex) in outerItem.main">
                  <!-- 最后一项 && 有赠品 -->
                  <template v-if="innerIndex + 1 == outerItem.main.length && outerItem.gifts && outerItem.gifts.length">
                    <GoodsItem :base="innerItem" :gifts="outerItem.gifts" :gift-name="outerItem.gift_rule_name" :key="innerItem.cart_item_id" />
                  </template>
                  <template v-else>
                    <GoodsItem :base="innerItem" :key="innerItem.cart_item_id" />
                  </template>
                </template>
              </template>
            </div>
            <!-- 全场赠品 -->
            <div class="m-cart_global_gifts" v-if="goods_list && Array.isArray(goods_list.another_group_gifts) && goods_list.another_group_gifts.length">
              <template v-for="(ggItem, ggIndex) in goods_list.another_group_gifts">
                <div class="m-cart_gifts_group" :key="`Checkout_Global_Gifts-${ggIndex}`" v-if="Array.isArray(ggItem.gifts) && ggItem.gifts.length">
                  <div class="subtitle">{{ ggItem.name }}</div>
                  <div class="trial-items full_sales">
                    <div class="item-base" v-for="(item, index) in ggItem.gifts" :key="index" style="margin-bottom: 20px;">
                      <div class="item-image">
                        <img :src="item.pic" :alt="item.name" />
                      </div>
                      <div class="item-intro">
                        <div class="item-name">{{item.name}}</div>
                        <div class="item-qty">数量：{{item.qty<1? 0 : item.qty}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <!-- 积分兑换商品 -->
            <template v-if="goods_list && Array.isArray(goods_list.product_coupon_sku) && goods_list.product_coupon_sku.length">
              <div class="subtitle">{{goods_list.product_coupon_name || '尊享礼遇'}}</div>
              <div class="trial-items score_exchange">
                <div class="item-base" v-for="(item, index) in goods_list.product_coupon_sku" :key="index" style="margin-bottom: 20px;">
                  <div class="item-image">
                    <img :src="item.pic" :alt="item.name" />
                  </div>
                  <div class="item-intro">
                    <div class="item-name">{{item.name}}</div>
                  </div>
                </div>
              </div>
            </template>
            <!-- 试用装商品 -->
            <template v-if="goods_list && Array.isArray(goods_list.free_try) && goods_list.free_try.length">
              <div class="subtitle">试用装商品</div>
              <div class="trial-items">
                <div class="item-base" v-for="(item, index) in goods_list.free_try" :key="index">
                  <div class="item-image">
                    <img :src="item.pic" :alt="item.name" />
                  </div>
                  <div class="item-intro">
                    <div class="item-name">{{item.name}}</div>
                  </div>
                </div>
              </div>
            </template>
			<!-- spa/服务促销赠品 -->
			<template v-if="goods_list && Array.isArray(goods_list.spa_try) && goods_list.spa_try.length>0">
					 <div style="margin-top: 30px;" class="subtitle">赠礼</div>
					 <div class="trial-items">
					   <div class="item-base" v-for="(item, index) in goods_list.spa_try" :key="index">
					     <div class="item-image">
					       <img :src="item.pic" :alt="item.name" />
					     </div>
					     <div class="item-intro">
					       <div class="item-name">{{item.name}}</div>
					     </div>
					   </div>
					 </div>
			</template>
			
          </div>
        </div>
        <!-- Banner -->
        <Club v-if="isLogin" :config="total && total.total_get_points || 0"/>
        <!-- 免费配送 -->
        <div class="item-tile free-shipping">
          <div class="tile-container">
            <!-- <div class="heading-h5">免费配送</div> -->
            <div class="action-group collapse">
              <div class="action-header clickable" @click="toggleActionGroup">
                <div class="action-title">需要帮助？</div>
                <i class="iconfont minus">&#xe604;</i>
                <i class="iconfont plus">&#xe627;</i>
              </div>
              <div class="action-body">
                <div class="online-service">咨询官网在线美容顾问，周一至周日，9:00-23:00。</div>
              </div>
            </div>
            <div class="action-group collapse">
              <div class="action-header clickable" @click="toggleActionGroup">
                <div class="action-title">尊贵礼盒</div>
                <i class="iconfont minus">&#xe604;</i>
                <i class="iconfont plus">&#xe627;</i>
              </div>
              <div class="action-body">
                <div class="online-service">您的每一个订单都将以精美的礼盒包装快递给您，尊享官网独家购物体验，是您礼献挚爱的倾情之选。</div>
              </div>
            </div>
            <div class="action-group collapse">
              <div class="action-header clickable" @click="toggleActionGroup">
                <div class="action-title">礼品卡</div>
                <i class="iconfont minus">&#xe604;</i>
                <i class="iconfont plus">&#xe627;</i>
              </div>
              <div class="action-body">
                <div class="online-service">如您购买的Sisley产品有送礼的需求，您可以在提交订单时添加礼品卡信息，我们会将其打印在礼品卡上并将其放置在包裹中。</div>
              </div>
            </div>
            <div class="action-group collapse">
              <div class="action-header clickable" @click="toggleActionGroup">
                <div class="action-title">配送方式</div>
                <i class="iconfont minus">&#xe604;</i>
                <i class="iconfont plus">&#xe627;</i>
              </div>
              <div class="action-body">
                <div class="online-service">所有订单将优先使用顺丰速运提供免费送货服务，对于顺丰无法送到的地区，我们将使用EMS运送。</div>
              </div>
            </div>
            <div class="action-group collapse">
              <div class="action-header clickable" @click="toggleActionGroup">
                <div class="action-title">退换货政策</div>
                <i class="iconfont minus">&#xe604;</i>
                <i class="iconfont plus">&#xe627;</i>
              </div>
              <div class="action-body">
                <div class="online-service">7天无理由退换货</div>
              </div>
            </div>
            <div class="action-group collapse">
              <div class="action-header clickable" @click="toggleActionGroup">
                <div class="action-title">电子发票</div>
                <i class="iconfont minus">&#xe604;</i>
                <i class="iconfont plus">&#xe627;</i>
              </div>
              <div class="action-body">
                <div class="online-service">增值税普通电子发票申请后，将在您订单签收的15个工作日之后发送至邮箱，您也可在“我的订单-已支付”中选择重新发送。</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 扫码付款 -->
    <Dialog :show="dialog == 1" wrapCls="wait_pay" @hide="reCheck">
      <div class="payment-header">
        <i class="iconfont payment-icon ali-pay" v-if="paymentMethod == 'AliPay' || paymentMethod == 'HuabeiPay'">&#xe660;</i>
        <i class="iconfont payment-icon wx-pay" v-if="paymentMethod == 'WeixinPay'">&#xe65b;</i>
        <span class="payment-text">{{ paymentMethod | typeify }}支付</span>
      </div>
      <div class="txt-lines" v-if="total && total.total_amount">
        <div class="txt-line">支付金额：<span class="txt-bold">￥{{total.total_amount}}</span></div>
        <template v-if="countdown && (countdown.m || countdown.s)">
          <div class="txt-line">距离二维码过期还剩<span class="txt-primary">{{countdown.m}}分{{countdown.s}}秒</span></div>
          <div class="txt-line">过期后请点击刷新重新获取二维码</div>
        </template>
        <template v-else>
          <div class="txt-line">二维码已失效</div>
          <div class="txt-line"><span class="link txt-primary" @click="refreshCode">刷新</span>并获取新二维码</div>
        </template>
      </div>
      <div class="qrcode-wrap" v-if="codeSrc">
        <template v-if="codeMode == 'image'">
          <img class="qrcode-imgage" :src="codeSrc" />
        </template>
        <template v-else-if="codeMode == 'iframe'">
          <iframe class="qrcode-iframe" :src="codeSrc" scrolling="no" align="middle" frameborder="0" seamless />
        </template>
        <div class="qrcode-mask" v-if="codeMask" @click="refreshCode">已失效</div>
      </div>
      <div class="txt-lines">
        <div class="txt-line">打开{{ paymentMethod | typeify }}扫一扫</div>
        <div class="txt-line">扫描上方二维码完成付款</div>
      </div>
    </Dialog>
    <!-- 支付结果 -->
    <Dialog :show="dialog == 2" wrapCls="pay-result" @hide="reCheck">
      <div class="txt-lines">
        <div class="txt-line txt-bold">支付结果</div>
        <div class="txt-line mt20">付款完成前请不要关闭窗口，</div>
        <div class="txt-line">完成付款后根据你的情况点击下方按钮！</div>
      </div>
      <button class="btn" @click="reCheck">已完成支付</button>
      <button class="btn btn-white" @click="toPayOrder(true)">支付遇到问题，重新支付</button>
    </Dialog>
    <!-- 货到付款 -->
    <Dialog :show="dialog == 3" wrapCls="freight_collect" @hide="toViewOrder">
      <div class="txt-lines">
        <div class="txt-line txt-bold">您的订单已提交成功</div>
        <div class="txt-line mt20">请您保持订单中预留的<span class="strong">电话号码畅通</span></div>
        <div class="txt-line">客服将尽快与您联系以便确认订单信息</div>
      </div>
      <button class="btn" @click="toViewOrder">确定</button>
    </Dialog>
    <!-- 地址弹窗 -->
    <Dialog :show="dialog == 4" wrapCls="address-dialog" @hide="onCloseDialog">
      <div class="form-header">
        <div class="form-title">{{ addressForm.id ? '编辑地址' : '添加地址' }}</div>
        <div class="form-desc">*号为必填</div>
      </div>
      <VForm class="ms-row" :model="addressForm" :rule="addressFormRules" ref="addressForm">
        <div class="col-xs-12 col-md-6">
          <FormItem prop="name">
            <input type="text" class="c-input c-input--fullwidth" placeholder="* 收货人姓名" v-model.trim="addressForm.name" maxlength="20" />
          </FormItem>
        </div>
        <div class="col-xs-12 col-md-6">
          <FormItem prop="sex">
            <MultiSelect v-model="addressForm.sex" :options="sexOpts" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="* 称谓"/>
          </FormItem>
        </div>
        <div class="col-xs-12 col-md-6">
          <FormItem prop="mobile">
            <input type="text" class="c-input c-input--fullwidth" placeholder="* 电话号码" v-model.trim="addressForm.mobile"  maxlength="11" />
          </FormItem>
        </div>
        <div class="col-xs-12 col-md-6">
          <FormItem prop="regions">
            <!-- <Cascader textField="name" valueField="isocode" extraCls="cascader-cls" 
              :source="districts" v-model="[addressForm.province, addressForm.city, addressForm.county]"
            /> -->
            <Cascader textField="name" valueField="name" hint="* 所在省市区" extraCls="cascader-cls" :source="districts" v-model="addressForm.regions"/>
          </FormItem>
        </div>
        <div class="col-xs-12 col-md-6">
          <FormItem prop="detail">
            <input type="text" class="c-input c-input--fullwidth" placeholder="* 详细地址" maxlength="30" v-model.trim="addressForm.detail" />
          </FormItem>
        </div>
        <div class="col-xs-12 col-md-6">
          <FormItem prop="zip_code">
            <input type="text" class="c-input c-input--fullwidth" placeholder="邮政编码（选填）" v-model="addressForm.zip_code" maxlength="6"/>
          </FormItem>
        </div>
        <div class="col-xs-12 col-md-6">
          <div class="default_address_opts float-left" @click="toggleDefAddress(addressForm)">
            <i class="iconfont">{{addressForm.is_default ? '&#xedaf;' : '&#xec58;'}}</i>设为默认地址
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <div class="save_address_info float-right">
            <button class="btn" @click="saveInfo">{{ addressForm.id ? '编辑地址' : '添加地址' }}</button>
          </div>
        </div>
      </VForm>
    </Dialog>
  </div>
</template>

<script>
import VForm from "@/components/form/my-form";
import FormItem from "@/components/form/form-item";
import MultiSelect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Cascader from '@/components/Cascader';
import Dialog from '@/components/Dialog';
import GoodsItem from '@/components/GoodsItem.vue';
import Club from '@/components/Club.vue';
import CouponSelect from '@/components/CouponSelect.vue';
import utils from '@/utils'
import districts from '@/assets/data/districts.json';
import types from '@/store/types';
import api from '@/utils/api';

// eslint-disable-next-line no-misleading-character-class
const regEmoji = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[A9|AE]\u3030|\uA9|\uAE|\u3030/ig;

export default {
  name: "Checkout",
  components: { VForm, FormItem, MultiSelect, Cascader, Dialog, GoodsItem, Club, CouponSelect },
  data() {
    const invoiceIDChecker = (rule, value, callback) => {
      if (this.invoice.type == "企业" && !value) {
        callback(new Error("请输入纳税人识别号"));
      } else if (value && !/^[A-Za-z0-9]+$/.test(value)) {
        callback(new Error("纳税人识别号为数字或字母格式"));
      } else {
        callback();
      }
    }
    return {
      districts,
      addressForm: {
        name: "",
        sex: "", // 性别: 1女 2男
        mobile: "",
        regions: [], // regions: ["北京", "北京市", "其它区"],
        // province: "",
        // city: "",
        // area: "",
        detail: "",
        zip_code: "",
        is_default: 0
      },
      addressFormRules: {
        name: [{
          required: true, validator(rule, value, callback) {
            if (!value) {
              callback(new Error("请输入收货人姓名"));
            } else if (regEmoji.test(value)) {
              callback(new Error("姓名中包含Emoji字符"));
            } else {
              callback();
            }
          }, trigger: "blur"
        }],
        sex: [{ required: true, message: "请选择称谓", trigger: "blur" }],
        mobile: [{
          required: true, validator(fieldRule, value, callback) {
            if (!value) {
              callback(new Error("请输入手机号码"));
            } else if (!/^1[3456789]\d{9}$/.test(value)) {
              callback(new Error("请输入正确的手机号码"));
            } else {
              callback();
            }
          }, trigger: "blur"
        }],
        regions: [{
          required: true, message: "请选择所在地区", type: "array",
          validator: (fieldRule, value, callback) => {
            if (value.length != 3) {
              callback(new Error("请选择地址"))
            } else {
              callback();
            }
          }, trigger: "blur"
        }],
        detail: [{
          required: true,
          validator(rule, value, callback) {
            if (!value) {
              callback(new Error("请输入详细地址"));
            } else if (regEmoji.test(value)) {
              callback(new Error("详细地址中不能包含Emoji字符"));
            } else {
              callback();
            }
          }, trigger: "blur"
        } ],
        zip_code: [{
          validator(rule, value, callback) {
            if (value && !/^\d+$/.test(value)) {
            console.log(value)
              callback(new Error("邮政编码为数字格式"));
            } else {
              callback();
            }
          }, trigger: "blur"
        }]
      },
      sexOpts: ['男士', '女士'],
      invoiceOpts: ['个人', '企业'],
      // 
      member_info: null, // 用户信息(地址列表)
      goods_list: null,  // 商品信息(商品列表&免费使用)
      used_points: null, // 积分抵扣
      total: null,       // 订单摘要
      goodsAmount: 0,    // 商品金额
      amount: 0,         // 订单总计
      // 
      selectedAddress: null,
      shippingMethod: 1,
      enableOfflinePayment: false,
      paymentMethod: "",
      allowPayStages: [],
      paymentStage: 0,
      paymentChannel: "NATIVE",
      useDiscount: false,
      invoice: null,
      invoiceRule: {
        title: [{ required: true, message: "请输入抬头名称", trigger: "blur"}],
        id: [{ validator: invoiceIDChecker, trigger: "blur" }],
        email: [{ required: true, validator(rule, value, callback) {
          if (!value) {
            callback(new Error("请输入邮箱地址"));
          } else if (!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(value)) {
            callback(new Error("邮箱格式不正确"));
          } else {
            callback();
          }
        }, trigger: "blur"}]
      },
      greetingCard: null,
      greetingCardRules: {
        to: [{ required: true, message: "请输入收卡人姓名", trigger: "blur"}],
        from: [{ required: true, message: "请输入送卡人姓名", trigger: "blur"}],
        content: [{ required: true, message: "请输入礼品卡内容", trigger: "blur"}]
      },
      eGiftCardType: 1,
      eGiftCardCode: "",
      agree: false,
      privacyCheckError: "",
      dialog: 0, // 1:支付扫码; 2:支付结果; 3:货到付款; 4:地址弹窗
      countdown: { m: 0, s: 0 },
      codeSrc: "",
      codeMode: "image",
      codeMask: false,
      payTitle: null,
      payRate: null,
      couponCard: [],
      order_remark: {
        show: false,
        value: "",
      },
    }
  },
  created() {
    // 不合规则的进入方式直接返回 -> 处理支付跳转
    let isOuter = utils.getItem("outer");
    if (isOuter) {
      this.$router.back();
    } else {
      // 移动端支付方式处理
      if (utils.isWXBrowser()) {
        this.allowPayMethod = [
          { text: '微信支付', value: 'WeixinPay', iconCls: 'wx-pay', iconText: '&#xe65c;', iconSymbol: 'iconweixinzhifu' }
        ];
        this.paymentChannel = 'JSAPI';
        // 没有OpenID则跳转到微信授权登录获取OpenID
        if (!this.$route.query.openid) {
          this.toAuthorization();
          return console.info('[info]:: 微信授权登录'), false;
        }
      } else if (utils.isMobile()) {
        this.allowPayMethod = [
          { text: '支付宝支付', value: 'AliPay', iconCls: 'ali-pay', iconText: '&#xe660;', iconSymbol: 'iconzhifubao' },
          { text: '微信支付', value: 'WeixinPay', iconCls: 'wx-pay', iconText: '&#xe65c;', iconSymbol: 'iconweixinzhifu' },
          { text: '银联支付', value: 'UnionPay', iconCls: 'union-pay', iconText: '&#xe65e;', iconSymbol: 'iconyinlian' },
          { text: '花呗支付', value: 'HuabeiPay', iconCls: 'ant_credit-pay', iconText: '&#xe659;', iconSymbol: 'iconhuabei' }
        ];
        this.paymentChannel = 'MWEB';
      } else {
        this.allowPayMethod = [
          { text: '支付宝支付', value: 'AliPay', iconCls: 'ali-pay', iconText: '&#xe660;', iconSymbol: 'iconzhifubao' },
          { text: '微信支付', value: 'WeixinPay', iconCls: 'wx-pay', iconText: '&#xe65c;', iconSymbol: 'iconweixinzhifu' },
          { text: '银联支付', value: 'UnionPay', iconCls: 'union-pay', iconText: '&#xe65e;', iconSymbol: 'iconyinlian' },
          { text: '花呗支付', value: 'HuabeiPay', iconCls: 'ant_credit-pay', iconText: '&#xe659;', iconSymbol: 'iconhuabei' }
        ];
        this.paymentChannel = 'NATIVE';
      }
      if(this.isLogin) {
        this.loadPage();
      } else {
        this.loadPageTourist();
      }
    }
  },
  mounted() {},
  methods: {
    // 
    onCloseDialog() {
      this.dialog = 0;
    },
    // 加载数据
    loadPage(force) {
      if (this.loading) return false;
      this.loading = true;
      // 
      let newArgs = {};
      let { couponCard, eGiftCardCode: code } = this;
      if (force) {
        newArgs.coupon_id = couponCard.length ? couponCard[0].coupon_id : "";
        newArgs.add_product_coupon_id = couponCard.length > 1 ? couponCard[1].coupon_id : '';
        newArgs.coupon_code = code || "";
      }
      api[types.ORDER_CONFIRM](newArgs).then(res => {
        this.loading = false;
        if (res.code == 1) {
          let { member_info, goods_list, total, used_points, coupon_id, coupon_code, add_product_coupon_id } = res.data;
          if (res.data?.error) {
            this.$toast({ message: "非常抱歉，您购物车中的部分商品已经没货了，请返回购物车重新提交", iconCls: "failure" });
            setTimeout(() => {
              this.$router.replace({ path: "/cart" });
            }, 1500);
            return false;
          }
          // 无效的优惠码
          res?.data?.error_message && this.$toast({ message: res.data.error_message, iconCls: "failure" });
          // 
          this.member_info = member_info;
          this.goods_list = goods_list;
          this.total = total;
          this.used_points = used_points;
          // 
          if (Array.isArray(this.goods_list.goods) && this.goods_list.goods.length) {
            this.goods_list.goods.forEach(group => {
              if (Array.isArray(group.main) && group.main.length) {
                group.main.forEach(o => {
                  console.log(o)
                });
              }
            });
          }
          // 
          if (this.member_info?.shipping_address?.length) {
            this.member_info.shipping_address = this.addressSort(this.member_info.shipping_address);
            // 地址簿只有一个地址时默认选中
            if (this.member_info.shipping_address.length == 1) {
              this.selectedAddress = this.member_info.shipping_address[0].shipping_address_id;
            } else {
              this.selectedAddress = this.member_info.shipping_address.find(item => item.is_default)?.shipping_address_id;
            }
          }
          // 当村你在积分兑换商品时禁用货到付款支付选项
          if (this.goods_list?.product_coupon_sku?.length) {
            // this.enableOfflinePayment = false; // 上线暂时放开，以便新客礼订单能正常
          }
          // 回填优惠券数据
          if(this.member_info?.coupon_list.length) {
            let _couponCard = [];
            this.member_info.coupon_list.forEach(i => {
                if((i.coupon_id === coupon_id || i.coupon_id === add_product_coupon_id) && !_couponCard.some(item => item.coupon_id === i.coupon_id) ) {
                  _couponCard.push(i)
                }
            })
            this.couponCard = _couponCard;
          }
          this.eGiftCardCode = coupon_code || "";
          // 
          this.getHBStages(total?.total_amount, goods_list);
          // 
          this.gtmTrackCheckoutStep(2);
        } else {
          this.$toast({ message: "非常抱歉，您购物车中的部分商品已经没货了，请返回购物车重新提交", iconCls: "failure" });
          setTimeout(() => {
            this.$router.back();
          }, 1000)
        }
      }).catch(err => {
        this.loading = false;
        console.warn(err);
      });
    },
    // 加载数据
    loadPageTourist(force) {
      if (this.loading) return false;
      this.loading = true;
      // 
      let newArgs = {};
      // 将本地购物车数据合并查询
      let localCart = utils.getCartInfo();
      if (localCart?.goods_list?.goods?.length) {
        newArgs = {};
        let arr = localCart.goods_list?.goods.filter(item => item.selected === true);
        let ret = arr.map(item => `${item.id},${item.quantity},${item.selected?1:0}`);
        newArgs.ids = ret.join("|");
        // 
        let free = localCart.goods_list.free_try.map(item => item.id);
        free.length && (newArgs.free_ids = free.join(","));
      }
      // 
      if ((!newArgs || !newArgs.ids)) {
        return console.info("[info] 无本地预购信息"), false;
      }
      api[types.VISITOR_CONFIRM](newArgs).then(res => {
        this.loading = false;
        if (res.code == 1) {
          let { member_info, goods_list, total, used_points, coupon_code } = res.data;
          if (res.data?.error) {
            this.$toast({ message: "非常抱歉，您购物车中的部分商品已经没货了，请返回购物车重新提交", iconCls: "failure" });
            setTimeout(() => {
              this.$router.replace({ path: "/cart" });
            }, 1500);
            return false;
          }
          // 无效的优惠码
          res?.data?.error_message && this.$toast({ message: res.data.error_message, iconCls: "failure" });
          // 
          this.member_info = member_info;
          this.goods_list = goods_list;
          this.total = total;
          this.used_points = used_points;
          // 
          if (Array.isArray(this.goods_list.goods) && this.goods_list.goods.length) {
            this.goods_list.goods.forEach(group => {
              if (Array.isArray(group.main) && group.main.length) {
                group.main.forEach(o => {
                  console.log(o)
                });
              }
            });
          }
          // 
          if (this.member_info?.shipping_address?.length) {
            this.member_info.shipping_address = this.addressSort(this.member_info.shipping_address);
            // 地址簿只有一个地址时默认选中
            if (this.member_info.shipping_address.length == 1) {
              this.selectedAddress = this.member_info.shipping_address[0].shipping_address_id;
            } else {
              this.selectedAddress = this.member_info.shipping_address.find(item => item.is_default)?.shipping_address_id;
            }
          }
          // 当村你在积分兑换商品时禁用货到付款支付选项
          if (this.goods_list?.product_coupon_sku?.length) {
            // this.enableOfflinePayment = false; // 上线暂时放开，以便新客礼订单能正常
          }
          this.eGiftCardCode = coupon_code || "";
          // 
          this.getHBStages(total?.total_amount, goods_list);
          // 
          this.gtmTrackCheckoutStep(2);
        } else {
          this.$toast({ message: "非常抱歉，您购物车中的部分商品已经没货了，请返回购物车重新提交", iconCls: "failure" });
          setTimeout(() => {
            this.$router.back();
          }, 1000)
        }
      }).catch(err => {
        this.loading = false;
        console.warn(err);
      });
    },
    getHBStages(amount,goods_list) {
      if (!amount || isNaN(amount)) return false;
      let ids = []
      if(goods_list && goods_list.goods) {
        ids = goods_list.goods.reduce((outerPrevious, outerItem) => {
          return outerPrevious.concat(outerItem.main.reduce((innerPrevious, innerItem) => {
            return innerPrevious.concat(innerItem.product_id);
          }, []));
        }, []);
      }
      api[types.ORDER_STAGES_INFO]({ money: amount,pdtIds: ids.join(',')}).then(res => {
        let { code, data } = res;
        if (code == 1) {
          this.allowPayStages = data.list;
          this.payTitle = data.title;
          this.payRate = data.payRate
        } else {
          console.warn(res);
        }
      });
    },
    // 重置地址表单
    resetAddressForm() {
      delete this.addressForm.id;
      this.addressForm = { name: "", sex: "", mobile: "", regions: [], detail: "", zip_code: "", is_default: false };
    },
    // 添加地址
    addNewAddress() {
      this.resetAddressForm();
      this.dialog = 4;
    },
    // 编辑地址
    editAddress(address) {
      this.resetAddressForm();
      let info = { ...address };
      info.shipping_address_id && (info.id = info.shipping_address_id);
      delete info.shipping_address_id;
      info.sex = info.sex == "man" ? "男士" : "女士";
      info.detail = info.address_detail;
      delete info.address_detail;
      info.regions = [info.province, info.city, info.district];
      delete info.province;
      delete info.city;
      delete info.district;
      info.zip_code = info.post_code;
      delete info.post_code;
      this.addressForm = info;
      this.dialog = 4;
    },
    // 删除地址
    removeAddress(address) {
      this.$confirm({
        message: "确定要删除该地址吗？",
        showCancel: true
      }).then(() => {
        api[types.ADDRESS_DELETE]({
          id: address.shipping_address_id
        }).then(res => {
          if (res.code == 1) {
            let idx = this.member_info.shipping_address.findIndex(item => item.shipping_address_id == address.shipping_address_id);
            if (idx != -1) {
              this.member_info.shipping_address.splice(idx, 1);
            }
            // 相等时置空已选中地址
            if (this.selectedAddress == address.shipping_address_id) {
              this.selectedAddress = null;
            }
          } else if (res.code != 2) {
            this.$toast({ message: res.message, iconCls: "failure" });
          }
        })
      }).catch(err => {
        console.warn(err);
      });
    },
    toggleDefAddress(address) {
      address.is_default = address.is_default ? 0 : 1;
    },
    // 设为默认地址
    setDefault(address) {
      if (!address.is_default) {
        api[types.ADDRESS_SET_DEFAULT]({
          id: address.shipping_address_id
        }).then(res => {
          if (res.code == 1) {
            this.member_info.shipping_address.forEach(item => {
              if (item.shipping_address_id == address.shipping_address_id) {
                item.is_default = 1;
              } else {
                item.is_default = 0;
              }
            });
            this.member_info.shipping_address = this.addressSort(this.member_info.shipping_address);
          } else if (res.code != 2) {
            this.$toast({ message: res.message, iconCls: "failure" });
          }
        }).catch(err => {
          console.warn(err);
        });
      }
    },
    // 保存地址信息
    saveInfo() {
      this.$refs.addressForm.validate().then(isValid => {
        if (isValid) {
          let newArgs = {...this.addressForm};
          newArgs.sex = newArgs.sex == "男士" ? 2 : 1;
          let [province, city, area] = newArgs.regions
          newArgs.province = province;
          newArgs.city = city;
          newArgs.area = area;
          delete newArgs.regions;
          newArgs.address = newArgs.detail;
          delete newArgs.detail;
          // 
          let xhrPath = types.ADDRESS_ADD;
          newArgs.id && (xhrPath = types.ADDRESS_UPDATE);
          // 
          api[xhrPath](newArgs).then(res => {
            if (res.code == 1) {
              if (newArgs.is_default) {
                this.member_info.shipping_address.forEach(item => {
                  item.is_default = 0;
                });
              }
              if (newArgs.id) {
                let idx = this.member_info.shipping_address.findIndex(item => item.shipping_address_id == newArgs.id);
                newArgs.district = newArgs.area;
                newArgs.address_detail = newArgs.address;
                this.member_info.shipping_address[idx] = Object.assign(this.member_info.shipping_address[idx], newArgs);
              } else {
                let addressCopy = {...res.data};
                addressCopy.shipping_address_id = addressCopy.id; delete addressCopy.id;
                addressCopy.district = addressCopy.area; delete addressCopy.area;
                addressCopy.address_detail = addressCopy.address; delete addressCopy.address;
                this.member_info.shipping_address.push(addressCopy);
              }
              // 
              this.member_info.shipping_address = this.addressSort(this.member_info.shipping_address);
              this.onCloseDialog();
            } else if (res.code != 2) {
              this.$toast({ message: res.message, iconCls: "failure" });
            }
          }).catch(err => {
            console.warn(err);
          });
        }
      });
    },
    addressSort(items) {
      return items.sort((a, b) => {
        if (a.is_default < b.is_default) {
          return 1;
        } else if (a.is_default > b.is_default) {
          return -1;
        } else {
          return 0;
        }
      });
    },
    // 切换配送方式
    toggleAddress(item) {
      this.selectedAddress = item.shipping_address_id;
    },
    // 切换支付方式
    togglePayment(method) {
      this.paymentMethod = method;
    },
    // 切换分期
    toggleStage(item) {
      this.paymentStage = item;
    },
    // 切换积分抵扣
    toggleDiscount() {
      this.useDiscount = !this.useDiscount;
    },
    // 切换电子发票
    toggleInvoice() {
      this.invoice = this.invoice ? null : { type: '个人' };
    },
    // 切换贺卡信息
    toggleGreetingCard() {
      this.greetingCard = this.greetingCard ? null : { to: "", from: "", content: "" };
    },
    // 备注
    toggleRemark() {
      this.order_remark = this.order_remark.show ? { show: false, value: ''} : { show: true, value: ''};
    },
    togglePrivacy() {
      this.agree = !this.agree;
      this.privacyCheckError = "";
    },
    // 优惠码输入框失焦
    onCouponCodeBlur() {
      this.useCoupon();
    },
    // 选择或反选电子礼券
    onSelectEGC() {
      setTimeout(() => {
        this.useCoupon();
      }, 0)
    },
    couponConfirm(item) {
      this.couponCard = item;
      setTimeout(() => {
        this.useCoupon();
      }, 0)
    },
    // 更新优惠券时重新请求数据
    useCoupon() {
      this.loadPage(true);
    },
    // 微信授权登录
    toAuthorization() {
      api[types.WX_WEB_AUTHORIZE]({
        href: location.href
      }).then(res => {
        if (res.code == 1) {
          location.href = res.data;
        } else {
          this.$message({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    // 立即结算 -> 参数校验
    async toCheckout() {
      if (this.loading) return console.log("正在加载中……"), false;
      let newArgs = {
        shipping_address_id: this.selectedAddress,
        coupon_code: this.eGiftCardCode,
        used_points: this.useDiscount ? 1 : 0,
        shipping_method: 'SF',
        payment_method: this.paymentMethod,
        trade_type: this.paymentChannel,
        accepted_flag: this.agree,
        guide: '',
        invoice: this.invoice ? Object.assign({}, this.invoice) : null,
        card: this.greetingCard ? Object.assign({}, this.greetingCard) : null,
        coupon_id: this.couponCard.length ? this.couponCard[0].coupon_id : "",
        add_product_coupon_id: this.couponCard.length > 1 ? this.couponCard[1].coupon_id : '',
        order_remark: this.order_remark.value,
      };
      if (!newArgs.shipping_address_id && this.isLogin) {
        if (this.member_info.shipping_address.length) {
          return this.$alert({ message: "请选择您的配送地址", iconCls: "failure" }), false;
        } else if (this.$refs.addressForm) {
          return this.$alert({ message: "请您先添加地址后再选择使用该地址", iconCls: "failure" }), false;
        }
      }
      if(!this.isLogin && (!this.addressForm.name || !this.addressForm.sex || !this.addressForm.mobile || !this.addressForm.detail || !this.addressForm.regions.length)) {
        return this.$alert({ message: "请完善配送地址", iconCls: "failure" }), false;
      }
      if (!newArgs.payment_method) return this.$alert({ message: "请选择支付方式", iconCls: "failure" }), false;
      if (newArgs.payment_method == "HuabeiPay" && !this.paymentStage) return this.$alert({ message: "请选择花呗分期期数", iconCls: "failure" }), false;
      if (newArgs.invoice && !await this.$refs.invoice.validate()) {
        return this.$alert({ message: "请完善您的电子发票信息", iconCls: "failure" }), false;
      }
      if (newArgs.card && !await this.$refs.greetingCard.validate()) {
        return this.$alert({ message: "请完善您的礼品卡信息", iconCls: "failure" }), false;
      }
      if (!newArgs.accepted_flag) {
        this.privacyCheckError = "请先阅读法国希思黎中国官网使用条款及隐私政策";
        return this.$alert({ message: "请先阅读法国希思黎中国官网使用条款及隐私政策", iconCls: "failure" }), false;
      } else {
        this.privacyCheckError = "";
      }
      // 
      this.gtmTrackCheckoutStep(3);
      this.gtmTrackCheckoutStep(4);
      //
      if(this.isLogin) {
        this.toCreateOrder(newArgs);
      } else {
        this.toCreateOrderVisitor(newArgs);
      }
    },
    // 创建订单
    toCreateOrder(newArgs) {
      // 
      if (this.creating) return console.info("请勿频繁提交订单"), false;
      this.creating = true;
      // 
      if (newArgs?.card?.content) {
        newArgs.card.content = newArgs.card.content.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>');
      }
      // 
      if (newArgs?.invoice?.type) {
        newArgs.invoice.type = newArgs.invoice.type == "个人" ? "person" : "company";
      }
      // 分享
      let share_uid = utils.getItem("share_uid");
      if (share_uid) {
        newArgs.share_uid = share_uid;
      }

      if(localStorage.getItem("channel")){
        newArgs.activityChannel = localStorage.getItem("channel")
      }
      if(localStorage.getItem("entrance")){
        newArgs.entrance = localStorage.getItem("entrance")
      }
      // 
      api[types.ORDER_CREATE](newArgs).then(res => {
        this.creating = false;
        if (res.code == 1) {
          // 同步购物车
          this.syncCartInfo();
          // 保存订单信息
          this.orderInfo = res.data;
          // 非“货到付款”方式需要发起支付
          if (this.paymentMethod != 'Offline') {
            this.toPayOrder(false);
          } else {
            // this.showCashOnDelivery();
            // // GTM
            // this.gtmTrackPurchase();
            // this.ylTrackPayment();
            // 
            this.reCheck(1);
          }
          // 上报
          if (this.orderInfo?.oms_return?.cps_link) {
            let img = new Image();
            img.onload = img.onerror = function() {
              img = null;
            };
            img.src = this.orderInfo.oms_return.cps_link;
          }
          // 
          utils.bdTracker('submit_order', this.getOrderTrackInfo());
          utils.bdTracker('pay', this.getOrderTrackInfo());
          if (Array.isArray(this.goods_list.goods) && this.goods_list.goods.length) {
            this.goods_list.goods.forEach(group => {
              if (Array.isArray(group.main) && group.main.length) {
                group.main.forEach(o => {
                  utils.bdTracker('payment_detail', {
                    product_id: o.unique_id,
                    product_name: o.name,
                    product_sku: o.sku,
                    product_category: '',
                    product_quantity: ~~o.qty,
                    product_price: ~~o.original_price,
                    product_amount: ~~o.total_price,
                    product_amount_paid: ~~o.paid_amount,
                    order_id: this.orderInfo.order_sn
                  });
                });
              }
            });
          }
        } else if (res.code != 2) {
          let msg = res.data?.oms_return?.message || res.message;
          this.$toast({ message: msg, iconCls: "failure" });
        }
      }).catch(err => {
        this.creating = false;
        this.$message({ message: err.message || "订单创建失败", iconCls: "failure" });
      });
    },
    // 游客创建订单
    toCreateOrderVisitor(newArgs) {
      console.log(this.addressForm)
      // 
      const { detail, mobile, name, regions, sex, zip_code} = this.addressForm;
      if (this.creating) return console.info("请勿频繁提交订单"), false;
      this.creating = true;
      // 
      if (newArgs?.card?.content) {
        newArgs.card.content = newArgs.card.content.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>');
      }
      newArgs.shipping_address = {
        name: name,
        sex,
        mobile,
        province: regions[0] || '',
        city: regions[1] || '',
        district: regions[2] || '',
        address_detail: detail,
        post_code: zip_code,
      }
      newArgs.openid = ''
      // 将本地购物车数据合并查询
      let localCart = utils.getCartInfo();
      if (localCart?.goods_list?.goods?.length) {
        let arr = localCart.goods_list?.goods.filter(item => item.selected === true);
        let ret = arr.map(item => `${item.id},${item.quantity},${item.selected?1:0}`);
        newArgs.ids = ret.join("|");
        // 
        let free = localCart.goods_list.free_try.map(item => item.id);
        free.length && (newArgs.free_ids = free.join(","));
      }
      // 
      if (newArgs?.invoice?.type) {
        newArgs.invoice.type = newArgs.invoice.type == "个人" ? "person" : "company";
      }
      // 分享
      let share_uid = utils.getItem("share_uid");
      if (share_uid) {
        newArgs.share_uid = share_uid;
      }

      if(localStorage.getItem("channel")){
        newArgs.activityChannel = localStorage.getItem("channel")
      }
      if(localStorage.getItem("entrance")){
        newArgs.entrance = localStorage.getItem("entrance")
      }
      // 
      api[types.VISITOR_CREATE](newArgs).then(res => {
        this.creating = false;
        if (res.code == 1) {
          // 同步购物车
          utils.updateOrderCart();
          this.syncCartInfo();
          // 保存订单信息
          this.orderInfo = res.data;
          // 非“货到付款”方式需要发起支付
          if (this.paymentMethod != 'Offline') {
            this.toPayOrder(false);
          } else {
            // this.showCashOnDelivery();
            // // GTM
            // this.gtmTrackPurchase();
            // this.ylTrackPayment();
            // 
            this.reCheck(1);
          }
          // 上报
          if (this.orderInfo?.oms_return?.cps_link) {
            let img = new Image();
            img.onload = img.onerror = function() {
              img = null;
            };
            img.src = this.orderInfo.oms_return.cps_link;
          }
          // 
          utils.bdTracker('submit_order', this.getOrderTrackInfo());
          utils.bdTracker('pay', this.getOrderTrackInfo());
          if (Array.isArray(this.goods_list.goods) && this.goods_list.goods.length) {
            this.goods_list.goods.forEach(group => {
              if (Array.isArray(group.main) && group.main.length) {
                group.main.forEach(o => {
                  utils.bdTracker('payment_detail', {
                    product_id: o.unique_id,
                    product_name: o.name,
                    product_sku: o.sku,
                    product_category: '',
                    product_quantity: ~~o.qty,
                    product_price: ~~o.original_price,
                    product_amount: ~~o.total_price,
                    product_amount_paid: ~~o.paid_amount,
                    order_id: this.orderInfo.order_sn
                  });
                });
              }
            });
          }
        } else if (res.code != 2) {
          let msg = res.data?.oms_return?.message || res.message;
          this.$toast({ message: msg, iconCls: "failure" });
        }
      }).catch(err => {
        this.creating = false;
        this.$message({ message: err.message || "订单创建失败", iconCls: "failure" });
      });
    },
    // 订单支付
    toPayOrder(isRetry) {
      if (!this.orderInfo || !this.orderInfo.order_sn) return console.log("订单信息为空或缺少order_sn => ", this.orderInfo), false;
      let { paymentMethod, paymentChannel } = this;
      // 
      if (paymentMethod == "UnionPay") {
        // TODO:: 路径需要注意
        window.open(`/pay?sn=${this.orderInfo.order_sn}&m=${paymentMethod}&t=${paymentChannel}`, '_blank');
        this.showPayResult();
      } else  {
        let newArgs = {
          order_sn: this.orderInfo.order_sn,
          payment_method: paymentMethod,
          trade_type: paymentChannel
        };
        if (paymentChannel == "JSAPI") {
          newArgs.openid = this.$route.query.openid;
        } else if (paymentMethod == 'HuabeiPay') {
          newArgs.hb_fp_num = this.paymentStage;
        }
        isRetry && (newArgs.again = 1);
        const method = this.isLogin ? types.ORDER_PAY : types.VISITOR_ORDER_PAY
        api[method](newArgs).then(res => {
          if (res.code == 1) {
            // 二维码方式
            if (paymentChannel == "NATIVE" && ["WeixinPay", "AliPay", "HuabeiPay"].indexOf(paymentMethod) != -1) {
              this.codeSrc = res.data;
              if (["AliPay", "HuabeiPay"].indexOf(paymentMethod) != -1) {
                this.codeMode = "iframe";
              } else {
                this.codeMode = "image";
              }
              this.waitPayTimer = this.startCountdown(4* 60, (times, timer) => {
                if (times > 0) {
                  this.countdown = { m: Math.floor(times/60), s: times % 60 };
                } else {
                  this.countdown = { m: 0, s: 0 };
                  this.codeMask = true;
                  timer && clearInterval(timer);
                  this.wsTimer && clearInterval(this.wsTimer);
                  this.wsInstance && this.wsInstance?.close();
                }
              });
              this.showPayCode();
              this.toQueryOrder();
            } else if (paymentChannel == "JSAPI") { // utils.isWXBrowser()
              this.toCallJSAPI(res.data);
            } else { // MWEB or utils.isMobile()
              utils.setItem("outer", 1);
              if (typeof res.data == "object") {
                location.href = res.data.mweb_url;
              } else {
                location.href = res.data;
              }
            }
          } else if (res.code != 2) {
            this.$message({ message: res.message, iconCls: "failure" });
          }
        }).catch(err => {
          console.warn(err);
        });
      }
    },
    // 检测JSAPI调用环境
    toCallJSAPI(args) {
      if (typeof window.WeixinJSBridge == "undefined"){
        if( document.addEventListener ){
            document.addEventListener('WeixinJSBridgeReady', () => this.onBridgeReady(args), false);
        }else if (document.attachEvent){
            document.attachEvent('WeixinJSBridgeReady', () => this.onBridgeReady(args));
            document.attachEvent('onWeixinJSBridgeReady', () => this.onBridgeReady(args));
        }
      }else{
        this.onBridgeReady(args);
      }
    },
    // JSAPI调用
    onBridgeReady(args) {
      let that = this;
      let { appId, timeStamp, nonceStr, signType, paySign } = args;
      if (appId && timeStamp && nonceStr && signType && paySign && args.package) {
        window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
          "appId": appId,
          "timeStamp": timeStamp,
          "nonceStr": nonceStr,
          "package": args.package,
          "signType": signType,
          "paySign": paySign
        }, function(res){
          if(res.err_msg == "get_brand_wcpay_request:ok"){
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            that.reCheck();
          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
            console.info("取消支付");
            setTimeout(() => {
              that.toViewOrder();
            });
          } else {
            console.warn('[getBrandWCPayRequest]:: ', res);
            that.$message({ message: "订单支付失败，请稍后重试", iconCls: "failure" });
            setTimeout(() => {
              that.toViewOrder();
            });
          }
        });
      } else {
        this.$message({ message: "网络异常", iconCls: "failure" });
        console.warn(args);
      }
    },
    // 订单支付状态查询
    toQueryOrder() {
      let wsInstance = api[types.ORDER_PAY_STATUS_QUERY](this.orderInfo.order_sn, (evt, ws) => {
        console.log('wsevt', evt);
        if (evt?.data) {
          try {
            let res = JSON.parse(evt.data);
            if (res?.code == 1) {
              this.reCheck();
              this.$message({ message: "支付成功", iconCls: "success" });
            } else {
              console.warn(res);
            }
          } catch (err) {
            console.warn(err);
          } finally {
            this.waitPayTimer && clearInterval(this.waitPayTimer);
            this.wsTimer && clearInterval(this.wsTimer);
            wsInstance?.close();
          }
        } else {
          this.waitPayTimer && clearInterval(this.waitPayTimer);
          this.wsTimer && clearInterval(this.wsTimer);
          ws?.close();
        }
      });
      // 每隔30秒发送一次消息确保链接不断
      this.wsTimer = setInterval(() => {
        wsInstance.send(JSON.stringify({ "orderId": this.orderInfo.order_sn }));
      }, 30 * 1000);
      this.wsInstance = wsInstance;
      return wsInstance;
    },
    // 
    reCheck(isCOD = 0) {
      this.waitPayTimer && clearInterval(this.waitPayTimer);
      this.wsTimer && clearInterval(this.wsTimer);
      this.wsInstance?.close();
      this.$router.replace({ path: `/payquery?sn=${this.orderInfo.order_sn}&cod=${isCOD}` });
    },
    // 支付成功
    showPaySuccess() {
      // 
      // this.$message({ message: "支付成功", iconCls: "success" });
      this.waitPayTimer && clearInterval(this.waitPayTimer);
      this.wsTimer && clearInterval(this.wsTimer);
      this.wsInstance?.close();
      this.onCloseDialog();
      this.toViewOrder();
    },
    // 显示“扫码付款”弹窗
    showPayCode() {
      this.dialog = 1;
    },
    // 显示“支付结果”弹窗
    showPayResult() {
      this.dialog = 2;
    },
    // 显示“货到付款”弹窗
    showCashOnDelivery() {
      this.dialog = 3;
    },
    // 查看订单
    toViewOrder() {
      this.waitPayTimer && clearInterval(this.waitPayTimer);
      this.wsTimer && clearInterval(this.wsTimer);
      this.wsInstance?.close();
      let newQuery = {};
      if (this.orderInfo.order_sn) {
        newQuery.sn = this.orderInfo.order_sn;
      }
      if (this.$route.query.openid) newQuery.openid = this.$route.query.openid;
      this.$router.replace({ path: '/myaccount/orders', query: newQuery });
    },
    // 开始制定秒数的倒计时
    startCountdown(times, callback) {
      if (isNaN(times)) return console.warn(`倒计时参数错误: ${times}`), false;
      if (typeof callback != "function") return console.warn("缺少倒计时结束回调函数"), false;
      callback(times);
      let timer = setInterval(() => {
        times--;
        if (times <= 0) {
          timer && clearInterval(timer);
        }
        callback(times, timer);
      }, 1000);
      return timer;
    },
    // 刷新支付码
    refreshCode() {
      this.codeMask = false;
      this.toPayOrder(true);
    },
    // 刷新购物车数据
    syncCartInfo(callback) {
      this.$store.dispatch(types.CART_GET, callback);
    },
    // 切换电子礼券方式
    toggleEGiftCard(type) {
      this.eGiftCardType = type;
    },
    // 右侧底部辅助信息展示状态切换
    toggleActionGroup(evt) {
      let dom = evt.target || evt.srcElement;
      let group = utils.closest(dom, '.action-group');
      group.classList.toggle("collapse");
    },
    // GTM Products
    gtmItemsHelper() {
      return this.goods_list.goods.reduce((ret, curr) => {
        return {
          items: ret.items.concat(curr.main.map(item => {
            return {
              id: item.sku,
              name: item.name,
              price: item.original_price,
              quantity: item.qty,
              productType: ['collection', 'collection_sku'].indexOf(item.display_type) != -1 ? 'bundle' : item.origin_product_data?.skus?.length > 1 ? 'configured' : 'simple',
              position: ret.count,
              pid: item.product_id
            };
          })),
          count: ret.count + curr.main.length
        }
      }, { items: [], count: 0 }).items;
    },
    // GTM 结算步骤
    gtmTrackCheckoutStep(step = 2) {
      if (!window.dataLayer) return false;
      window.dataLayer.push({
        event: 'checkout',
        ecommerce: {
          checkout: {
            actionField: { step },
            products: this.gtmItemsHelper()
          }
        }
      });
    },
    // GTM 付款成功
    gtmTrackPurchase() {
      if (!window.dataLayer || !this?.orderInfo?.order_sn) return false;
      window.dataLayer.push({
        ecommerce: {
          currencyCode: 'CNY',
          purchase: {
            actionField: {
              step: 5,
              currencyCode: 'CNY',
              id: this.orderInfo.order_sn,                                                // Order ID
              affiliation: this.paymentChannel == 'NATIVE' ? 'Desktop' : 'Mobile',        // Store name
              revenue: this.total.total_amount,                                           // 总金额（含增值税，含运费）
              revenueHt: this.total.total_amount,                                         // 总金额（不含增值税），包括运费
              tax: '0.00',                                                                // 税费
              shipping: this.total.total_ship_fee,                                        // 邮费
              transactionGift: 'False',                                                   // Gift
              transactionShippingService: 'SF',                                           // 快递
              transactionShippingFree: this.total.total_ship_fee == 0 ? 'True' : 'False', // 免邮
              transactionPayment: this.paymentMethod || '',                               // 支付方式
              coupon: this?.eGiftCardCode || '',                                          // 优惠码
              coupon_id: this.couponCard.length ? this.couponCard[0].coupon_id : ""                                 // 优惠券ID
            },
            products: this.gtmItemsHelper()
          }
        }
      });
    },
    // 品数监测# 下单
    ylTrackOrder() {
      if (window?.YLTrackerz?.track) {
        // 
        window?.YLTrackerz?.track({
          type: 'transaction',
          orderId: this.orderInfo.order_sn,
          total: this.total.total_amount,
          checkout: this.total.total_amount,
          shipping: this.total.total_ship_fee,
          payment: this.paymentMethod == 'Offline' ? '2' : '1',
          platform: { 'AliPay': '支付宝', 'WeixinPay': '微信', 'UnionPay': '银联', 'HuabeiPay': '支付宝'}[this.paymentMethod] || this.paymentMethod,
          uid: this.$store.state?.userInfo?.id || ''
        });
        // 
        let items = this.gtmItemsHelper();
        items.forEach(item => {
          window.YLTrackerz.track({
            type: 'item',
            orderId: this.orderInfo.order_sn,
            sku: item.id,
            price: item.price,
            quantity: item.quantity,
            product: item.name,
            category: 'none',
            hrand: '希思黎',
            pid: item.pid
          });
        });
      }
    },
    // 品数监测# 付款
    ylTrackPayment() {
      if (window?.YLTrackerz?.track) {
        window?.YLTrackerz?.track({
          type: 'payment',
          orderId: this.orderInfo.order_sn,
          total: this.total.total_amount,
          checkout: this.total.total_amount,
          shipping: this.total.total_ship_fee,
          payment: this.paymentMethod == 'Offline' ? '2' : '1',
          platform: { 'AliPay': '支付宝', 'WeixinPay': '微信', 'UnionPay': '银联', 'HuabeiPay': '支付宝'}[this.paymentMethod] || this.paymentMethod,
          uid: this.$store.state?.userInfo?.id || ''
        });
      }
    },
    getOrderTrackInfo() {
      if (!this.orderInfo || !this.total) return null;
      // 
      const isUsedCoupon = (this.couponCard?.length || this.eGiftCardCode) ? true : false;
      return {
        order_id: this.orderInfo.order_sn,
        order_amount: this.total.total_product_price,
        order_amount_paid: this.total.total_amount,
        use_coupon: isUsedCoupon ? 1 : 0,
        coupon_id: isUsedCoupon ? (this.eGiftCardType === 1 ? this.couponCard[0]?.coupon_id : this.eGiftCardCode) : '',
        coupon_amount: '',
        use_m_point: 0,
        m_point_amount: 0,
        discount: this.total.total_discount,
        freight_cost: this.total.total_ship_fee,
        payment_method: this.paymentMethod
      };
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    disabledSubmit() {
      if (
        !this.selectedAddress || !this.paymentChannel || !this.paymentMethod ||
        (this?.invoice?.type == "个人" && (!this.invoice.title || !this.invoice.email)) ||
        (this?.invoice?.type == "企业" && (!this.invoice.title || !this.invoice.id || !this.invoice.email)) ||
        (this.greetingCard && (!this.greetingCard.from || !this.greetingCard.to || !this.greetingCard.content)) ||
        !this.agree
      ) {
        return true;
      }
      return false;
    }
  },
  filters: {
    typeify(peymentMethod) {
      let typesMap = { 'AliPay': '支付宝', 'WeixinPay': '微信', 'UnionPay': '银联', 'HuabeiPay': '支付宝'};
      return typesMap[peymentMethod];
    }
  }
}
</script>

<style lang="scss" scoped>
  .privacy_err--msg { font-size: 12px; color: #c53131; margin-left: 20px; }
  .cascader-cls {
    & /deep/ .cascader-title { padding: 0.875rem 1rem 0.8125rem; line-height: 16px; border: 1px solid #CCCCCC; border-radius: 1.40625rem; }
  }
  .btn { color: #FFFFFF; background: #000000; }
  .mt20 { margin-top: 1rem; }
  .checkout-wrapper {
    box-sizing: border-box;
    & > .ms-row { margin: 0; }
    .header-logo { padding: 2rem 0 5.5rem 0; display: flex; justify-content: center; }
    .header-breadcrumb {
      padding: 0.625rem 0;
      .link-with-arrow {
        margin-left: 0.625rem; color: #666666;
        &:after { right: auto; left: -0.625rem; transform: rotate(-90deg); }
      }
    }
    .page-title { font-weight: 700; }
  }
  .item-tile {
    margin: 2rem 0;
    .tile-title {
      display: flex; justify-content: flex-start; align-items: center;
      .heading-h4 { font-size: 18px; font-weight: 700; margin-bottom: 0; white-space: nowrap; }
      .title-desc {
        font-size:14px; color: #575757;
        &.float-left { margin-left: 0.625rem; }
      }
      .title-btn { width:120px; height:32px; padding: 8px 0; font-size: 14px; color: #333333; background: #FFFFFF; border: 1px solid #D2D2D2; border-radius: 16px; }
      &.space-between { justify-content: space-between; }
    }
    .tile-container {
      &.tile-border { border: 1px solid #D2D2D2; margin-top: 20px; }
      &.tile-padding { padding: 1.5625rem 1.25rem; }
      &.address-list { display: flex; flex-wrap: wrap; }
      .address-item {
        width: 100%; height: 160px; margin: 20px 0 0 0; padding: 20px; position: relative;
        display: flex; flex-direction: column; justify-content: space-between; border: 1px solid #DFDFDF; 
        .tick { font-size: 24px; color: #000; position: absolute; top: -8px; right: -1px; display: none; }
        .address-extra {
          display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;
          .user-info {
            display: flex; justify-content: flex-start; align-items: center; font-size: 14px; color: #333333; width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;
            .user-name { font-weight: 700; }
            .user-mobile { margin-left: 20px; }
          }
          .address-items { font-size: 14px; color: #666666; margin-top: 6px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        }
        .address-actions {
          display: flex; justify-content: space-between; align-items: center;
          .address-isDefault { font-size: 14px; color: #999999; cursor: pointer; }
          .address-btns {
            display: flex; justify-content: flex-end; align-items: center;
            .iconfont {
              margin-left: 22px;
              &:first-child { margin-left: 0; }
            }
          }
        }
        &:nth-child(2n) { margin-right: 0; }
        &.active {
          border: 1px solid #000000;
          .tick { display: block; }
        }
      }
      .field-box { box-sizing: border-box; width: 100%; margin-bottom: 20px; }
      .c-input { border: 1px solid #CCCCCC; }
      .module {
        margin: 20px 0 10px 0;
        .module_header {
          display: flex; justify-content: flex-start; align-items: baseline;
          .module_title {
            font-size: 16px; color: #333333; white-space: nowrap;
            .iconfont { margin-right: 4px; }
          }
          .module_desc {
            font-size: 14px; color: #575757; line-height: 18px;
            &.float-left { margin-left: 0.625rem; }
            &.ml0 { margin-left: 0; }
            a { font-size: 14px; color: #575757; }
          }
        }
        .module_container {
          display: flex; margin-top: 20px;
        }
      }
      .action-group {
        border-bottom: 1px solid #DCDCDC; transition: height 0.2s ease-in;
        .action-header {
          height: 52px; display: flex; justify-content: space-between; align-items: center;
        }
        .action-body {
          padding-bottom: 20px;
          .online-service {
            font-size: 12px; display: flex; justify-content: flex-start; align-items: center;
            .iconfont { margin-right: 4px; }
          }
        }
        .minus { display: block; }
        .plus { display: none; }
        &.collapse {
          height: 52px; overflow: hidden;
          .minus { display: none }
          .plus { display: block; }
        }
      }
    }
    .default_address_opts {
      display: flex; justify-content: flex-start; align-items: center; cursor: pointer; height: 44px; 
      color: #333333;
    }
    .choose-option {
      position: relative; display: flex; justify-content: center; align-items: center; margin: 0 20px 20px 0; cursor: pointer;
      width: calc(50% - 10px); height: 50px; border: 1px solid #D2D2D2; border-radius:4px; background:rgba(255,255,255,1);
      &:last-child { margin-right: 0; }
      &:nth-child(2n) { margin-right: 0; }
      &.active {
        border: 1px solid #333333;
        .tick { display: block; }
        // &::before {
        //   content:'';
        //   display: block; height: 0; width: 0; font-size: 0; border: 12px solid transparent;
        //   border-right: 12px solid #000; border-top: 12px solid #000; position: absolute; top: 0; right: 0;
        // }
      }
      .tick { display: none; position: absolute; top: -8px; right: -1px; font-size: 24px; color: #000000; }
      .car-icon { font-size: 24px; }
      .sf-express { font-size: 20px; color: #333333; }
      i.ali-pay { font-size: 22px; color: #4F9BF3; }
      svg.ali-pay { color: #4F9BF3; width: 1.375rem; }
      i.wx-pay { font-size: 22px; color: #54A802; }
      svg.wx-pay { color: #4F9BF3; width: 1.375rem; }
      i.union-pay { font-size: 22px; color: unset; }
      svg.union-pay { width: 1.875rem; }
      i.ant_credit-pay { font-size: 22px; color: #30B4FF; }
      svg.ant_credit-pay { color: #30B4FF; width: 1.375rem; }
      .freight_collect { font-size: 18px; color: #333333; }
      .option-name { height: 16px; font-size: 16px; font-weight: 400; color: rgba(34,34,34,1); margin-left: 5px; line-height: 16px; white-space: nowrap; }
    }
    .online_payment .module_container { flex-wrap: wrap; }
    .stages_wrap {
      background: #F5F5F5; padding: 10px; margin-top: 0 !important; position: relative;
      .choose-option {
        width: 100%; height: 72px; margin: 10px 0 0 0; flex-direction: column;
        &:first-child { margin-top: 0; }
        .option-name {
          width: 100%; display: flex; justify-content: space-between; align-items: center; margin: 0; padding: 0 10px;
          font-size: 14px; color: #1B1B1B; line-height: 17px; font-weight: 700;
        }
        .option-desc {
          width: 100%; display: flex; justify-content: space-between; align-items: center; margin: 0; padding: 0 10px;
          font-size: 12px; color: #999999; line-height: 14px; margin-top: 6px;
        }
      }
      &::after {
        content: '';
        position: absolute; top: -14px; right: 25%; transform: translateX(50%);
        width:0; height:0; 
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 14px solid #F5F5F5;
      }
      &.stages_1 .choose-option { width: 100%; margin: 0; }
      .stage_msg { font-size: 12px; color: #999; line-height: 1.5; margin-top: 0.625rem; }
    }
    &.border-top { border-top: 1px solid #D7D8D8; margin-top: -1rem; }
    &.greeting-card {
      .ipt-multi-wrap {
        width: 100%; height: 140px; position: relative;
        &:after {
          content: attr(data-count) "/" attr(data-max); font-size: 12px; color: #A3A3A3; line-height: 12px;
          position: absolute; bottom: 15px; right: 15px;
        }
        .ipt-multi { width: 100%; height: 100%; resize: none; }
      }
    }
  }
  .default_address_opts { color: #333333; cursor: pointer; }
  .summary .heading-h5, .goods-list .heading-h5 { font-size: 14px; font-weight: 700; }
  .kv-line {
    display: flex; justify-content: space-between; align-items: center; font-size: 12px; color: #5E5E5E; line-height: 28px;
  }
  .tab-wrap {
    .tab-header {
      display: flex; justify-content: flex-start; align-items: center;
      .tab-title {
        font-size: 12px; color: #5E5E5E; margin-left: 1rem; cursor: pointer;
        &:first-child { margin-left: 0; }
        &.active { color: #000000; text-decoration: underline; font-weight: 700; }
      }
    }
    .tab-body {
      padding: 20px 0;
      .e-gift_card {
        select { width: 100%; height: 44px; border: 1px solid #CCCCCC; border-radius: 1.40625rem; padding: 0 0.625rem; }
      }
    }
  }
  .summary .tab-wrap { margin-top: 1rem; }
  .total-info {
    .kv-line { font-size: 16px; color: #282828; }
  }
  .create-order__btn {
    .btn--primary {
      width: 100%; margin-top: 1.375rem;
      &[disabled] { opacity: 0.6; cursor: not-allowed; }
    }
  }
  .payment-methods {
    display: flex; justify-content: space-around; align-items: center; margin-top: 1rem;
    .iconfont { font-size: 24px; color: #C0C0C0; }
  }
  .goods-list {
    .subtitle { font-size: 12px; color: #666666; }
    // 商品信息
    .goods-items {
      margin-top: 20px; padding-bottom: 30px; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;
      // & /deep/ .goods_item-wrap .item-base .item-intro .item-info .item-info-l .item-desc .item-desc_info { display: none; }
    }
    // 试用商品
    .trial-items {
      margin-top: 30px;
      // 商品信息基本结构布局
      .item-base {
        width: 100%; margin-top: 30px; display: flex; justify-content: flex-start; align-items: flex-start;
        &:first-child { margin-top: 0; }
        .item-image { width: 60px; min-width: 60px; height: 80px; }
        .item-intro {
          margin-left: 20px; width: calc(100% - 80px); height: 80px;
          display: flex; flex-direction: column; justify-content: center;
          .item-name { font-size: 14px; color: #000; }
          .item-qty { font-size: 12px; line-height: 1; margin-top: 0.625rem; }
        }
      }
    }
  }
  // 付款扫码
  ::v-deep .wait_pay .dialog-container {
    width: 470px; height: 570px;
    .dialog-body {
      flex-direction: column; justify-content: flex-start; align-items: center;
      .payment-header {
        display: flex; justify-content: center; align-items: center; margin-top: 56px; width: 100%;
        .payment-icon {
          font-size: 40px;
          &.ali-pay { color: #4F9BF3; }
          &.wx-pay { color: #54A802; }
        }
        .payment-text { font-size: 20px; color: #333333; margin-left: 10px; }
      }
      .txt-lines {
        width: 100%; text-align: center; margin-top: 6px;
        .txt-line { font-size: 14px; color: #666666; }
        .txt-bold { font-size: 25px; color: #C4172E; }
        .txt-primary { font-size: inherit; color: #C4172E; margin: 0 6px; }
      }
      .qrcode-wrap {
        width: 190px; height: 190px; margin: 20px auto; position: relative;
        .qrcode-imgage { width: 100%; }
        .qrcode-iframe { width: 190px; height: 190px; padding: 20px; }
        .qrcode-mask {
          position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.8); cursor: pointer;
          display: flex; justify-content: center; align-items: center; color: white; font-size: 20px;
        }
      }
    }
  }
  // 付款结果
  ::v-deep .pay-result .dialog-container {
    width: 470px; max-width: 90%; height: 310px;
    .dialog-body {
      flex-direction: column; justify-content: flex-start; align-items: center;
    }
    .txt-lines { width: 100%; display: flex; flex-direction: column; justify-content: flex-start; align-items: center; margin-top: 64px; }
    .txt-line { width: 100%; text-align: center; font-size: 12px; color: #666666; line-height: 24px; }
    .txt-bold, .strong { font-size: 16px; font-weight: 700; color: #333333; }
    .btn { width: 300px; margin-top: 20px; padding: 0.8125rem 0;  }
    .btn-white { background: #FFFFFF; color: #333333; border: 1px solid #C0C0C0; }
  }
  // 货到付款
  ::v-deep .freight_collect .dialog-container {
    width: 470px; max-width: 90%; height: 258px;
    .dialog-body {
      flex-direction: column; justify-content: flex-start; align-items: center;
    }
    .txt-lines { width: 100%; display: flex; flex-direction: column; justify-content: flex-start; align-items: center; margin-top: 64px; }
    .txt-line { width: 100%; text-align: center; font-size: 12px; color: #333333; line-height: 24px; }
    .txt-bold, .strong { font-size: 16px; font-weight: 700; color: #333333; }
    .strong { font-size: 12px; }
    .btn { width: 300px; margin-top: 20px; }
  }
  // 地址弹窗
  ::v-deep .address-dialog .dialog-container {
    width: 726px; max-width: 100%; height: 630px;
    .dialog-header {
      .dialog-close {
        display: flex; justify-content: center; align-items: center;
        .close-icon {
          width: 24px; height: 24px; border-radius: 50%;
          .iconfont { font-size: 22px; color: #2C2C2C; }
        }
      }
    }
    .dialog-body {
      padding: 40px; flex-direction: column;
      .form-header {
        display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;
        .form-title { font-size: 18px; color: #333333; font-weight: 700; }
        .form-desc { font-size: 12px; color: #7C7D7C; }
      }
    }
  }
  // 
  @media screen and (min-width: 48em) {
    .item-tile {
      .tile-container {
        .address-item { width: calc(50% - 10px); margin: 20px 20px 0 0; }
      }
      .stages_wrap {
        &.stages_2 {
          .choose-option {
            width: calc((100% - 10px) / 2);
            &:first-child { margin-right: 10px; }
            &:nth-child(2n) { margin-top: 0; margin-right: 0; }
          }
        }
        &.stages_3 {
          .choose-option {
            width: calc((100% - 20px) / 3);
            &:nth-child(-n+2) { margin-right: 10px; }
            &:nth-child(n+1) { margin-top: 0; }
            &:nth-child(3) { margin-right: 0; }
          }
        }
      }
    }
  }
  @media screen and (max-width: 63.9375em) {
    .checkout-wrapper {
      .header-logo { padding: 0.625rem 0; }
      .header-breadcrumb { padding: 0 1.25rem; }
      .page-title { padding: 0 1.25rem; margin-top: 2rem; font-size: 18px; }
    }
    .item-tile {
      padding: 0 1.25rem;
      .tile-title {
        padding: 0; flex-direction: column; align-items: flex-start;
        .heading-h4 { font-size: 16px; }
        .title-desc.float-left { margin-left: 0; margin-top: 1rem; }
        &.space-between { flex-direction: row; justify-content: space-between; align-items: center; }
      }
      .tile-container {
        &.tile-border { border: none; margin-top: 0; }
        &.tile-padding { padding: 0.625rem 0; }
        .module {
          .module_header {
            flex-direction: column; align-items: flex-start;
            .module_desc.float-left { margin-left: 0; margin-top: 1rem; }
            &.nowrap {
              flex-direction: row; align-items: center;
              .module_desc {  margin-top: 0; }
            }
          }
        }
      }
    }
    .default_address_opts { height: 45px; }
    .save_address_info {
      width: 100%;
      .btn { width: 100%; }
    }
  }
  @media screen and (min-width: 64em) {
    .checkout-wrapper {
      .page-title { margin-top: 50px; }
    }
    .item-tile {
      .choose-option {
        // width: 183px;
        width: calc((100% - 60px) / 4);
        &:nth-child(2n) { margin-right: 20px;  }
        &:last-child { margin-right: 0; }
      }
      .stages_wrap {
        .choose-option { margin-right: 10px; }
        &.stages_2 {
          .choose-option {
            width: calc((100% - 10px) / 2);
            &:first-child { margin-right: 10px; }
            &:nth-child(2n) { margin-top: 0; margin-right: 0; }
          }
        }
        &.stages_3 {
          .choose-option {
            width: calc((100% - 20px) / 3);
            &:nth-child(-n+2) { margin-right: 10px; }
            &:nth-child(n+1) { margin-top: 0; }
            &:nth-child(3) { margin-right: 0; }
          }
        }
      
        &::after { right: 12.5%; }
      }
      .tile-container {
        .address-item {
          // width: 250px;
          width: calc((100% - 40px) / 3);
          &:nth-child(2n) { margin-right: 20px; }
          &:nth-child(3n) { margin-right: 0px; }
        }
        .field-box { padding: 25px 20px 0 20px; border: 1px solid #D2D2D2; }
      }
    }
    .goods-list {
      .item-base {
        .item-image { width: 80px; min-width: 80px; height: 106px; }
        .item-intro {
          margin-left: 15px; width: calc(100% - 95px); height: 106px;
        }
      }
    }
    .default_address_opts { line-height: 44px; }
    .save_address_info { width: auto; }
    ::v-deep .address-dialog .dialog-container {
      height: 380px; 
    }
  }
  @media screen and (max-width: 74.9375em) {
    // .tile-title { padding: 0 1.25rem; }
  }
</style>